var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginScreenDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 960,
    viewBox: "0 0 1440 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5175_27353)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 960,
    fill: "#1A1C1E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5175_27353)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M825.935 158.67L825.768 158.569L751.133 115.532V29.2553L751.3 29.1549L825.935 -13.8828L826.103 -13.7824L900.738 29.2553V115.532L900.57 115.632L825.935 158.67ZM751.769 115.13L825.935 157.9L900.068 115.13V29.59L825.935 -13.18L751.769 29.59V115.13Z",
    fill: "url(#paint0_linear_5175_27353)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M974.873 158.67L974.705 158.569L900.07 115.532V29.2553L900.238 29.1549L974.873 -13.8828L975.04 -13.7824L1049.68 29.2553V115.532L1049.51 115.632L974.873 158.67ZM900.74 115.13L974.873 157.9L1049.04 115.13V29.59L974.873 -13.18L900.74 29.59V115.13Z",
    fill: "url(#paint1_linear_5175_27353)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 158.67L1123.64 158.569L1049.01 115.532V29.2553L1049.18 29.1549L1123.81 -13.8828L1123.98 -13.7824L1198.61 29.2553V115.532L1198.45 115.632L1123.81 158.67ZM1049.68 115.13L1123.81 157.9L1197.94 115.13V29.59L1123.81 -13.18L1049.68 29.59V115.13Z",
    fill: "url(#paint2_linear_5175_27353)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.78 158.67L1272.61 158.569L1197.98 115.532V29.2553L1198.14 29.1549L1272.78 -13.8828L1272.95 -13.7824L1347.58 29.2553V115.532L1347.41 115.632L1272.78 158.67ZM1198.61 115.13L1272.78 157.9L1346.91 115.13V29.59L1272.78 -13.18L1198.61 29.59V115.13Z",
    fill: "url(#paint3_linear_5175_27353)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 147.356L1421.71 157.898L1347.54 115.128V29.6218L1421.71 -13.1482L1440 -2.60633V-3.37606L1421.88 -13.8176L1421.71 -13.918L1347.07 29.1533L1346.91 29.2202V115.53L1421.54 158.568L1421.71 158.668L1440 148.126V147.356Z",
    fill: "url(#paint4_linear_5175_27353)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.662 287.514L155.494 287.413L80.8594 244.375V158.099L81.0269 157.999L155.662 114.961L155.829 115.061L230.464 158.099V244.375L230.297 244.476L155.662 287.514ZM81.5294 244.007L155.662 286.777L229.828 244.007V158.467L155.662 115.697L81.5294 158.467V244.007Z",
    fill: "url(#paint5_linear_5175_27353)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M900.404 287.514L900.237 287.413L825.602 244.375V158.099L825.769 157.999L900.404 114.961L900.572 115.061L975.207 158.099V244.375L975.039 244.476L900.404 287.514ZM826.238 244.007L900.371 286.777L974.537 244.007V158.467L900.371 115.697L826.238 158.467V244.007Z",
    fill: "url(#paint6_linear_5175_27353)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 287.514L1049.17 287.413L974.539 244.375V158.099L974.707 157.999L1049.34 114.961L1049.51 115.061L1124.14 158.099V244.375L1123.98 244.476L1049.34 287.514ZM975.209 244.007L1049.38 286.777L1123.51 244.007V158.467L1049.38 115.697L975.209 158.467V244.007Z",
    fill: "url(#paint7_linear_5175_27353)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 287.514L1198.1 287.413L1123.47 244.375V158.099L1123.64 157.999L1198.27 114.961L1198.44 115.061L1273.07 158.099V244.375L1272.91 244.476L1198.27 287.514ZM1124.14 244.007L1198.27 286.777L1272.44 244.007V158.467L1198.27 115.697L1124.14 158.467V244.007Z",
    fill: "url(#paint8_linear_5175_27353)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 287.514L1347.07 287.413L1272.44 244.375V158.099L1272.61 157.999L1347.24 114.961L1347.41 115.061L1422.04 158.099V244.375L1421.88 244.476L1347.24 287.514ZM1273.07 244.007L1347.21 286.777L1421.34 244.007V158.467L1347.21 115.697L1273.07 158.467V244.007Z",
    fill: "url(#paint9_linear_5175_27353)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 254.381L1422.01 244.006V158.466L1440 148.125V147.355L1421.54 157.998L1421.38 158.098V244.374L1440 255.117V254.381Z",
    fill: "url(#paint10_linear_5175_27353)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 416.392L1123.64 416.292L1049.01 373.254V286.978L1049.18 286.878L1123.81 243.84L1123.98 243.94L1198.61 286.978V373.254L1198.45 373.355L1123.81 416.392ZM1049.68 372.886L1123.81 415.656L1197.94 372.886V287.346L1123.81 244.576L1049.68 287.346V372.886Z",
    fill: "url(#paint11_linear_5175_27353)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.78 416.392L1272.61 416.292L1197.98 373.254V286.978L1198.14 286.878L1272.78 243.84L1272.95 243.94L1347.58 286.978V373.254L1347.41 373.355L1272.78 416.392ZM1198.61 372.886L1272.78 415.656L1346.91 372.886V287.346L1272.78 244.576L1198.61 287.346V372.886Z",
    fill: "url(#paint12_linear_5175_27353)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 405.079L1421.71 415.654L1347.54 372.884V287.344L1421.71 244.574L1440 255.116V254.38L1421.88 243.905L1421.71 243.805L1347.07 286.876L1346.91 286.976V373.253L1421.54 416.29L1421.71 416.391L1440 405.849V405.079Z",
    fill: "url(#paint13_linear_5175_27353)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 545.24L1198.1 545.14L1123.47 502.102V415.826L1123.64 415.725L1198.27 372.688L1198.44 372.788L1273.07 415.826V502.102L1272.91 502.202L1198.27 545.24ZM1124.14 501.734L1198.27 544.504L1272.44 501.734V416.194L1198.27 373.424L1124.14 416.194V501.734Z",
    fill: "url(#paint14_linear_5175_27353)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 545.24L1347.07 545.14L1272.44 502.102V415.826L1272.61 415.725L1347.24 372.688L1347.41 372.788L1422.04 415.826V502.102L1421.88 502.202L1347.24 545.24ZM1273.07 501.734L1347.21 544.504L1421.34 501.734V416.194L1347.21 373.424L1273.07 416.194V501.734Z",
    fill: "url(#paint15_linear_5175_27353)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 512.107L1422.01 501.733V416.193L1440 405.852V405.082L1421.54 415.724L1421.38 415.825V502.101L1440 512.844V512.107Z",
    fill: "url(#paint16_linear_5175_27353)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 674.119L229.994 674.019L155.359 630.981V544.705L155.527 544.604L230.162 501.566L230.329 501.667L304.964 544.705V630.981L304.797 631.081L230.162 674.119ZM155.996 630.613L230.128 673.383L304.261 630.613V545.073L230.128 502.303L155.996 545.073V630.613Z",
    fill: "url(#paint17_linear_5175_27353)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.78 674.119L1272.61 674.019L1197.98 630.981V544.705L1198.14 544.604L1272.78 501.566L1272.95 501.667L1347.58 544.705V630.981L1347.41 631.081L1272.78 674.119ZM1198.61 630.613L1272.78 673.383L1346.91 630.613V545.073L1272.78 502.303L1198.61 545.073V630.613Z",
    fill: "url(#paint18_linear_5175_27353)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 662.841L1421.71 673.383L1347.54 630.613V545.073L1421.71 502.303L1440 512.845V512.108L1421.88 501.633L1421.71 501.566L1347.07 544.604L1346.91 544.705V630.981L1421.54 674.019L1421.71 674.119L1440 663.577V662.841Z",
    fill: "url(#paint19_linear_5175_27353)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M155.662 802.998L155.494 802.897L80.8594 759.86V673.583L81.0269 673.483L155.662 630.445L155.829 630.546L230.464 673.583V759.86L230.297 759.96L155.662 802.998ZM81.5294 759.458L155.662 802.228L229.828 759.458V673.918L155.662 631.148L81.5294 673.918V759.458Z",
    fill: "url(#paint20_linear_5175_27353)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M304.631 802.998L304.463 802.897L229.828 759.86V673.583L229.996 673.483L304.631 630.445L304.798 630.546L379.433 673.583V759.86L379.266 759.96L304.631 802.998ZM230.465 759.458L304.597 802.228L378.73 759.458V673.918L304.597 631.148L230.465 673.918V759.458Z",
    fill: "url(#paint21_linear_5175_27353)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M453.568 802.998L453.401 802.897L378.766 759.86V673.583L378.933 673.483L453.568 630.445L453.736 630.546L528.371 673.583V759.86L528.203 759.96L453.568 802.998ZM379.402 759.458L453.535 802.228L527.667 759.458V673.918L453.535 631.148L379.402 673.918V759.458Z",
    fill: "url(#paint22_linear_5175_27353)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M602.498 802.998L602.33 802.897L527.695 759.86V673.583L527.863 673.483L602.498 630.445L602.665 630.546L677.3 673.583V759.86L677.133 759.96L602.498 802.998ZM528.365 759.458L602.531 802.228L676.664 759.458V673.918L602.531 631.148L528.365 673.918V759.458Z",
    fill: "url(#paint23_linear_5175_27353)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 769.832L1422.01 759.457V673.951L1440 663.576V662.84L1421.54 673.482L1421.38 673.549V759.859L1440 770.568V769.832Z",
    fill: "url(#paint24_linear_5175_27353)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M230.162 931.842L229.994 931.741L155.359 888.704V802.427L155.527 802.327L230.162 759.289L230.329 759.389L304.964 802.427V888.704L304.797 888.804L230.162 931.842ZM155.996 888.335L230.128 931.105L304.261 888.335V802.795L230.128 760.025L155.996 802.795V888.335Z",
    fill: "url(#paint25_linear_5175_27353)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M379.099 931.842L378.932 931.741L304.297 888.704V802.427L304.464 802.327L379.099 759.289L379.267 759.389L453.902 802.427V888.704L453.734 888.804L379.099 931.842ZM304.933 888.335L379.099 931.105L453.232 888.335V802.795L379.099 760.025L304.933 802.795V888.335Z",
    fill: "url(#paint26_linear_5175_27353)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M528.037 931.842L527.869 931.741L453.234 888.704V802.427L453.402 802.327L528.037 759.289L528.204 759.389L602.839 802.427V888.704L602.672 888.804L528.037 931.842ZM453.904 888.335L528.037 931.105L602.169 888.335V802.795L528.037 760.025L453.904 802.795V888.335Z",
    fill: "url(#paint27_linear_5175_27353)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5271 979.998V931.673L155.66 888.903L229.826 931.673V979.998H230.462V931.305L155.827 888.233L155.66 888.133L81.0246 931.204L80.8906 931.305V979.998H81.5271Z",
    fill: "url(#paint28_linear_5175_27353)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M230.465 979.998V931.673L304.631 888.903L378.763 931.673V979.998H379.4V931.305L304.798 888.233L304.631 888.133L229.996 931.204L229.828 931.305V979.998H230.465Z",
    fill: "url(#paint29_linear_5175_27353)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M379.402 979.998V931.673L453.568 888.903L527.701 931.673V979.998H528.371V931.305L453.736 888.233L453.568 888.133L378.933 931.204L378.766 931.305V979.998H379.402Z",
    fill: "url(#paint30_linear_5175_27353)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M528.365 979.998V931.673L602.498 888.903L676.664 931.673V979.998H677.3V931.305L602.665 888.233L602.498 888.133L527.863 931.204L527.695 931.305V979.998H528.365Z",
    fill: "url(#paint31_linear_5175_27353)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.14 979.998V931.673L1198.28 888.903L1272.44 931.673V979.998H1273.08V931.305L1198.44 888.233L1198.28 888.133L1123.64 931.204L1123.51 931.305V979.998H1124.14Z",
    fill: "url(#paint32_linear_5175_27353)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.07 979.998V931.673L1347.24 888.903L1421.37 931.673V979.998H1422.01V931.305L1347.37 888.233L1347.24 888.133L1272.61 931.204L1272.44 931.305V979.998H1273.07Z",
    fill: "url(#paint33_linear_5175_27353)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.7 148.027L1003.95 91.0668V-22.8527L1102.7 -79.8125L1201.45 -22.8527V91.0668L1102.7 148.027ZM1007.33 89.1592L1102.7 144.178L1198.07 89.1592V-20.8782L1102.7 -75.8969L1007.33 -20.8782V89.1592Z",
    fill: "url(#paint34_linear_5175_27353)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.82 148.027L1198.07 91.0668V-22.8527L1296.82 -79.8125L1395.58 -22.8527V91.0668L1296.82 148.027ZM1201.45 89.1592L1296.82 144.178L1392.2 89.1592V-20.8782L1296.82 -75.8969L1201.45 -20.8782V89.1592Z",
    fill: "url(#paint35_linear_5175_27353)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 114.762L1395.55 89.1602V-20.8772L1440 -46.5124V-50.3945L1392.2 -22.8182V91.1013L1440 118.644V114.762Z",
    fill: "url(#paint36_linear_5175_27353)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.75 315.995L1100.99 259.036V145.116L1199.75 88.1562L1298.5 145.116V259.036L1199.75 315.995ZM1104.38 257.094L1199.75 312.113L1295.12 257.094V147.057L1199.75 92.0383L1104.38 147.057V257.094Z",
    fill: "url(#paint37_linear_5175_27353)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 285.505L1393.87 312.111L1298.5 257.092V147.055L1393.87 92.0696L1440 118.642V114.76L1393.87 88.1875L1295.12 145.114V259.033L1393.87 315.993L1440 289.387V285.505Z",
    fill: "url(#paint38_linear_5175_27353)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 284.938V288.853L33.3907 315.024V425.028L-12 451.198V455.114L36.7406 426.969V313.083L-12 284.938Z",
    fill: "url(#paint39_linear_5175_27353)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M132.113 483.929L33.3594 426.969V313.05L132.113 256.09L230.868 313.05V426.969L132.113 483.929ZM36.7427 425.028L132.113 480.047L227.484 425.028V314.991L132.113 259.972L36.7427 314.991V425.028Z",
    fill: "url(#paint40_linear_5175_27353)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M326.238 483.929L227.484 426.969V313.05L326.238 256.09L424.993 313.05V426.969L326.238 483.929ZM230.868 425.028L326.238 480.047L421.609 425.028V314.991L326.238 259.972L230.868 314.991V425.028Z",
    fill: "url(#paint41_linear_5175_27353)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 450.664L1395.55 425.029V315.025L1440 289.39V285.508L1392.2 313.084V426.97L1440 454.546V450.664Z",
    fill: "url(#paint42_linear_5175_27353)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0656 424.055L-12 451.196V455.111L35.0656 427.937L130.436 482.955V592.993L35.0656 647.978L-12 620.837V624.719L35.0656 651.894L133.82 594.934V481.014L35.0656 424.055Z",
    fill: "url(#paint43_linear_5175_27353)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M229.192 651.894L130.438 594.934V481.014L229.192 424.055L327.946 481.014V594.934L229.192 651.894ZM133.821 592.993L229.192 648.012L324.562 592.993V482.955L229.192 427.937L133.821 482.955V592.993Z",
    fill: "url(#paint44_linear_5175_27353)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M423.285 651.894L324.531 594.934V481.014L423.285 424.055L522.039 481.014V594.934L423.285 651.894ZM327.915 592.993L423.285 648.012L518.656 592.993V482.955L423.285 427.937L327.915 482.955V592.993Z",
    fill: "url(#paint45_linear_5175_27353)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 620.84V624.722L33.3907 650.926V760.93L-12 787.101V790.983L36.7406 762.871V648.952L-12 620.84Z",
    fill: "url(#paint46_linear_5175_27353)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132.113 819.831L33.3594 762.871V648.952L132.113 591.992L230.868 648.952V762.871L132.113 819.831ZM36.7427 760.93L132.113 815.949L227.484 760.93V650.893L132.113 595.874L36.7427 650.893V760.93Z",
    fill: "url(#paint47_linear_5175_27353)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M326.238 819.831L227.484 762.871V648.952L326.238 591.992L424.993 648.952V762.871L326.238 819.831ZM230.868 760.93L326.238 815.949L421.609 760.93V650.893L326.238 595.874L230.868 650.893V760.93Z",
    fill: "url(#paint48_linear_5175_27353)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.82 819.831L1198.07 762.871V648.952L1296.82 591.992L1395.58 648.952V762.871L1296.82 819.831ZM1201.45 760.93L1296.82 815.949L1392.2 760.93V650.893L1296.82 595.874L1201.45 650.893V760.93Z",
    fill: "url(#paint49_linear_5175_27353)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 960.62L21.5992 979.997H28.3324L-12 956.738V960.62Z",
    fill: "url(#paint50_linear_5175_27353)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0656 759.957L-12 787.098V790.98L35.0656 763.839L130.436 818.858V928.862L41.7989 979.998H48.5321L133.82 930.836V816.917L35.0656 759.957Z",
    fill: "url(#paint51_linear_5175_27353)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M222.458 979.998L133.821 928.862V818.858L229.192 763.839L324.562 818.858V928.862L235.925 979.998H242.658L327.912 930.836V816.917L229.192 759.957L130.438 816.917V930.836L215.692 979.998H222.458Z",
    fill: "url(#paint52_linear_5175_27353)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M416.55 979.998L327.912 928.862V818.858L423.283 763.839L518.654 818.858V928.862L430.05 979.998H436.783L522.037 930.836V816.917L423.283 759.957L324.562 816.917V930.836L409.817 979.998H416.55Z",
    fill: "url(#paint53_linear_5175_27353)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.01 979.998L1104.37 928.862V818.858L1199.74 763.839L1295.11 818.858V928.862L1206.51 979.998H1213.24L1298.5 930.836V816.917L1199.74 759.957L1101.02 816.917V930.836L1186.28 979.998H1193.01Z",
    fill: "url(#paint54_linear_5175_27353)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.87 763.839L1440 790.445V786.563L1393.87 759.957L1295.12 816.917V930.836L1380.4 979.998H1387.14L1298.5 928.862V818.858L1393.87 763.839Z",
    fill: "url(#paint55_linear_5175_27353)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 957.273L1400.6 979.997H1407.33L1440 961.189V957.273Z",
    fill: "url(#paint56_linear_5175_27353)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 956.742V960.624L21.5992 980.001H28.3324L-12 956.742Z",
    fill: "url(#paint57_linear_5175_27353)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5301 980.002L132.109 931.81L215.689 980.002H222.455L132.109 927.895L41.7969 980.002H48.5301Z",
    fill: "url(#paint58_linear_5175_27353)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M242.655 980.002L326.234 931.81L409.813 980.002H416.547L326.234 927.895L235.922 980.002H242.655Z",
    fill: "url(#paint59_linear_5175_27353)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M436.78 980.002L520.359 931.81L603.938 980.002H610.672L520.359 927.895L430.047 980.002H436.78Z",
    fill: "url(#paint60_linear_5175_27353)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M630.907 980.002L714.487 931.81L798.032 980.002H804.799L714.487 927.895L624.141 980.002H630.907Z",
    fill: "url(#paint61_linear_5175_27353)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M824.999 980.002L908.578 931.81L992.157 980.002H998.89L908.578 927.895L818.266 980.002H824.999Z",
    fill: "url(#paint62_linear_5175_27353)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.12 980.002L1102.7 931.81L1186.28 980.002H1193.02L1102.7 927.895L1012.39 980.002H1019.12Z",
    fill: "url(#paint63_linear_5175_27353)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.25 980.002L1296.83 931.81L1380.41 980.002H1387.14L1296.83 927.895L1206.52 980.002H1213.25Z",
    fill: "url(#paint64_linear_5175_27353)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 957.277L1400.61 980.001H1407.34L1440 961.193V957.277Z",
    fill: "url(#paint65_linear_5175_27353)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M230.164 163.623C233.112 163.623 235.524 161.214 235.524 158.269C235.524 155.324 233.112 152.914 230.164 152.914C227.217 152.914 224.805 155.324 224.805 158.269C224.805 161.214 227.217 163.623 230.164 163.623Z",
    fill: "url(#paint66_linear_5175_27353)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M751.472 19.1484C745.81 19.1484 741.188 23.7333 741.188 29.4226C741.188 35.1119 745.777 39.6968 751.472 39.6968C757.166 39.6968 761.756 35.1119 761.756 29.4226C761.756 23.7333 757.166 19.1484 751.472 19.1484Z",
    fill: "url(#paint67_linear_5175_27353)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M751.471 121.757C755.022 121.757 757.903 118.879 757.903 115.332C757.903 111.784 755.022 108.906 751.471 108.906C747.92 108.906 745.039 111.784 745.039 115.332C745.039 118.879 747.92 121.757 751.471 121.757Z",
    fill: "url(#paint68_linear_5175_27353)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M825.936 164.06C829.118 164.06 831.731 161.483 831.731 158.27C831.731 155.057 829.152 152.48 825.936 152.48C822.72 152.48 820.141 155.057 820.141 158.27C820.141 161.483 822.72 164.06 825.936 164.06Z",
    fill: "url(#paint69_linear_5175_27353)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M900.404 35.3114C903.653 35.3114 906.299 32.6676 906.299 29.4213C906.299 26.1751 903.653 23.5312 900.404 23.5312C897.154 23.5312 894.508 26.1751 894.508 29.4213C894.508 32.6676 897.154 35.3114 900.404 35.3114Z",
    fill: "url(#paint70_linear_5175_27353)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M900.406 104.988C894.677 104.988 890.055 109.607 890.055 115.329C890.055 121.052 894.677 125.67 900.406 125.67C906.134 125.67 910.757 121.052 910.757 115.329C910.757 109.607 906.134 104.988 900.406 104.988Z",
    fill: "url(#paint71_linear_5175_27353)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 37.4545C1053.76 37.4545 1057.38 33.8736 1057.38 29.4225C1057.38 24.9715 1053.79 21.3906 1049.34 21.3906C1044.88 21.3906 1041.3 24.9715 1041.3 29.4225C1041.3 33.8736 1044.88 37.4545 1049.34 37.4545Z",
    fill: "url(#paint72_linear_5175_27353)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 124.901C1054.63 124.901 1058.92 120.615 1058.92 115.329C1058.92 110.043 1054.63 105.758 1049.34 105.758C1044.05 105.758 1039.76 110.043 1039.76 115.329C1039.76 120.615 1044.05 124.901 1049.34 124.901Z",
    fill: "url(#paint73_linear_5175_27353)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.28 35.1804C1201.46 35.1804 1204.04 32.6035 1204.04 29.4242C1204.04 26.2449 1201.46 23.668 1198.28 23.668C1195.1 23.668 1192.52 26.2449 1192.52 29.4242C1192.52 32.6035 1195.1 35.1804 1198.28 35.1804Z",
    fill: "url(#paint74_linear_5175_27353)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.28 119.448C1200.55 119.448 1202.4 117.605 1202.4 115.331C1202.4 113.058 1200.55 111.215 1198.28 111.215C1196 111.215 1194.16 113.058 1194.16 115.331C1194.16 117.605 1196 119.448 1198.28 119.448Z",
    fill: "url(#paint75_linear_5175_27353)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.25 35.5138C1350.63 35.5138 1353.34 32.7695 1353.34 29.4229C1353.34 26.0763 1350.6 23.332 1347.25 23.332C1343.9 23.332 1341.15 26.0763 1341.15 29.4229C1341.15 32.7695 1343.9 35.5138 1347.25 35.5138Z",
    fill: "url(#paint76_linear_5175_27353)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 122.257C1351.07 122.257 1354.17 119.156 1354.17 115.33C1354.17 111.504 1351.07 108.402 1347.24 108.402C1343.41 108.402 1340.3 111.504 1340.3 115.33C1340.3 119.156 1343.41 122.257 1347.24 122.257Z",
    fill: "url(#paint77_linear_5175_27353)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M155.662 280.32C151.877 280.32 148.828 283.399 148.828 287.147C148.828 290.896 151.91 293.975 155.662 293.975C159.414 293.975 162.529 290.896 162.529 287.147C162.529 283.399 159.447 280.32 155.662 280.32Z",
    fill: "url(#paint78_linear_5175_27353)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1963 248.529C83.5829 248.529 85.5177 246.596 85.5177 244.212C85.5177 241.827 83.5829 239.895 81.1963 239.895C78.8097 239.895 76.875 241.827 76.875 244.212C76.875 246.596 78.8097 248.529 81.1963 248.529Z",
    fill: "url(#paint79_linear_5175_27353)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1969 161.548C83.0059 161.548 84.4798 160.075 84.4798 158.268C84.4798 156.461 83.0059 154.988 81.1969 154.988C79.388 154.988 77.9141 156.461 77.9141 158.268C77.9141 160.075 79.388 161.548 81.1969 161.548Z",
    fill: "url(#paint80_linear_5175_27353)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M155.665 125.337C161.196 125.337 165.681 120.857 165.681 115.331C165.681 109.804 161.196 105.324 155.665 105.324C150.133 105.324 145.648 109.804 145.648 115.331C145.648 120.857 150.133 125.337 155.665 125.337Z",
    fill: "url(#paint81_linear_5175_27353)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M230.166 252.609C234.822 252.609 238.574 248.827 238.574 244.209C238.574 239.59 234.789 235.809 230.166 235.809C225.543 235.809 221.758 239.59 221.758 244.209C221.758 248.827 225.543 252.609 230.166 252.609Z",
    fill: "url(#paint82_linear_5175_27353)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M825.936 251.942C830.224 251.942 833.707 248.462 833.707 244.178C833.707 239.895 830.224 236.414 825.936 236.414C821.648 236.414 818.164 239.895 818.164 244.178C818.164 248.462 821.648 251.942 825.936 251.942Z",
    fill: "url(#paint83_linear_5175_27353)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M974.869 154.32C972.692 154.32 970.883 156.094 970.883 158.303C970.883 160.512 972.658 162.285 974.869 162.285C977.08 162.285 978.856 160.512 978.856 158.303C978.856 156.094 977.08 154.32 974.869 154.32Z",
    fill: "url(#paint84_linear_5175_27353)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M974.87 251.573C978.923 251.573 982.239 248.293 982.239 244.21C982.239 240.127 978.957 236.848 974.87 236.848C970.783 236.848 967.5 240.127 967.5 244.21C967.5 248.293 970.783 251.573 974.87 251.573Z",
    fill: "url(#paint85_linear_5175_27353)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 291.8C1051.91 291.8 1053.99 289.717 1053.99 287.148C1053.99 284.579 1051.91 282.496 1049.34 282.496C1046.76 282.496 1044.68 284.579 1044.68 287.148C1044.68 289.717 1046.76 291.8 1049.34 291.8Z",
    fill: "url(#paint86_linear_5175_27353)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.81 147.426C1117.81 147.426 1112.92 152.278 1112.92 158.302C1112.92 164.326 1117.78 169.179 1123.81 169.179C1129.84 169.179 1134.7 164.326 1134.7 158.302C1134.7 152.278 1129.84 147.426 1123.81 147.426Z",
    fill: "url(#paint87_linear_5175_27353)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.78 166.369C1277.23 166.369 1280.85 162.755 1280.85 158.304C1280.85 153.853 1277.23 150.238 1272.78 150.238C1268.32 150.238 1264.7 153.853 1264.7 158.304C1264.7 162.755 1268.32 166.369 1272.78 166.369Z",
    fill: "url(#paint88_linear_5175_27353)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 295.181C1351.7 295.181 1355.28 291.567 1355.28 287.149C1355.28 282.732 1351.66 279.117 1347.24 279.117C1342.82 279.117 1339.2 282.732 1339.2 287.149C1339.2 291.567 1342.82 295.181 1347.24 295.181Z",
    fill: "url(#paint89_linear_5175_27353)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.78 253.68C1278 253.68 1282.26 249.43 1282.26 244.209C1282.26 238.989 1278 234.738 1272.78 234.738C1267.55 234.738 1263.3 238.989 1263.3 244.209C1263.3 249.43 1267.55 253.68 1272.78 253.68Z",
    fill: "url(#paint90_linear_5175_27353)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 166.901C1426.47 166.901 1430.36 163.053 1430.36 158.267C1430.36 153.481 1426.5 149.633 1421.71 149.633C1416.92 149.633 1413.07 153.481 1413.07 158.267C1413.07 163.053 1416.92 166.901 1421.71 166.901Z",
    fill: "url(#paint91_linear_5175_27353)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M906.598 287.148C906.598 283.735 903.817 280.957 900.4 280.957C896.984 280.957 894.203 283.735 894.203 287.148C894.203 290.562 896.984 293.34 900.4 293.34C903.817 293.34 906.598 290.562 906.598 287.148Z",
    fill: "url(#paint92_linear_5175_27353)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.8 249.196C1126.56 249.196 1128.8 246.963 1128.8 244.209C1128.8 241.455 1126.56 239.223 1123.8 239.223C1121.05 239.223 1118.81 241.455 1118.81 244.209C1118.81 246.963 1121.05 249.196 1123.8 249.196Z",
    fill: "url(#paint93_linear_5175_27353)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 292.502C1201.22 292.502 1203.63 290.126 1203.63 287.148C1203.63 284.169 1201.26 281.793 1198.27 281.793C1195.29 281.793 1192.91 284.169 1192.91 287.148C1192.91 290.126 1195.29 292.502 1198.27 292.502Z",
    fill: "url(#paint94_linear_5175_27353)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 421.314C1424.63 421.314 1427 418.946 1427 416.026C1427 413.106 1424.63 410.738 1421.71 410.738C1418.78 410.738 1416.41 413.106 1416.41 416.026C1416.41 418.946 1418.78 421.314 1421.71 421.314Z",
    fill: "url(#paint95_linear_5175_27353)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 366.16C1343.43 366.16 1340.34 369.239 1340.34 373.054C1340.34 376.869 1343.43 379.948 1347.24 379.948C1351.06 379.948 1354.15 376.869 1354.15 373.054C1354.15 369.239 1351.06 366.16 1347.24 366.16Z",
    fill: "url(#paint96_linear_5175_27353)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 250.803C1425.35 250.803 1428.31 247.851 1428.31 244.21C1428.31 240.569 1425.35 237.617 1421.71 237.617C1418.06 237.617 1415.11 240.569 1415.11 244.21C1415.11 247.851 1418.06 250.803 1421.71 250.803Z",
    fill: "url(#paint97_linear_5175_27353)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M155.659 537.039C151.338 537.039 147.82 540.553 147.82 544.87C147.82 549.187 151.338 552.701 155.659 552.701C159.98 552.701 163.498 549.187 163.498 544.87C163.498 540.553 159.98 537.039 155.659 537.039Z",
    fill: "url(#paint98_linear_5175_27353)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1957 502.636C81.5842 502.636 81.8991 502.321 81.8991 501.933C81.8991 501.545 81.5842 501.23 81.1957 501.23C80.8071 501.23 80.4922 501.545 80.4922 501.933C80.4922 502.321 80.8071 502.636 81.1957 502.636Z",
    fill: "url(#paint99_linear_5175_27353)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1939 422.286C84.6536 422.286 87.4582 419.484 87.4582 416.028C87.4582 412.571 84.6536 409.77 81.1939 409.77C77.7343 409.77 74.9297 412.571 74.9297 416.028C74.9297 419.484 77.7343 422.286 81.1939 422.286Z",
    fill: "url(#paint100_linear_5175_27353)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M155.659 367.668C152.678 367.668 150.266 370.078 150.266 373.056C150.266 376.035 152.678 378.444 155.659 378.444C158.64 378.444 161.052 376.035 161.052 373.056C161.052 370.078 158.64 367.668 155.659 367.668Z",
    fill: "url(#paint101_linear_5175_27353)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M299.742 544.87C299.742 547.548 301.92 549.757 304.633 549.757C307.346 549.757 309.524 547.581 309.524 544.87C309.524 542.16 307.346 539.984 304.633 539.984C301.92 539.984 299.742 542.16 299.742 544.87Z",
    fill: "url(#paint102_linear_5175_27353)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.34 365.125C1044.95 365.125 1041.37 368.672 1041.37 373.09C1041.37 377.508 1044.92 381.055 1049.34 381.055C1053.76 381.055 1057.31 377.508 1057.31 373.09C1057.31 368.672 1053.76 365.125 1049.34 365.125Z",
    fill: "url(#paint103_linear_5175_27353)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.53 416.028C1115.53 420.579 1119.22 424.294 1123.81 424.294C1128.39 424.294 1132.08 420.613 1132.08 416.028C1132.08 411.443 1128.39 407.762 1123.81 407.762C1119.22 407.762 1115.53 411.443 1115.53 416.028Z",
    fill: "url(#paint104_linear_5175_27353)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 549.86C1201.03 549.86 1203.26 547.627 1203.26 544.873C1203.26 542.119 1201.03 539.887 1198.27 539.887C1195.52 539.887 1193.28 542.119 1193.28 544.873C1193.28 547.627 1195.52 549.86 1198.27 549.86Z",
    fill: "url(#paint105_linear_5175_27353)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.8 508.426C1127.39 508.426 1130.3 505.52 1130.3 501.934C1130.3 498.348 1127.39 495.441 1123.8 495.441C1120.21 495.441 1117.3 498.348 1117.3 501.934C1117.3 505.52 1120.21 508.426 1123.8 508.426Z",
    fill: "url(#paint106_linear_5175_27353)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.28 379.984C1202.11 379.984 1205.21 376.882 1205.21 373.056C1205.21 369.23 1202.11 366.129 1198.28 366.129C1194.45 366.129 1191.34 369.23 1191.34 373.056C1191.34 376.882 1194.45 379.984 1198.28 379.984Z",
    fill: "url(#paint107_linear_5175_27353)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.78 511.772C1278.22 511.772 1282.63 507.367 1282.63 501.933C1282.63 496.499 1278.22 492.094 1272.78 492.094C1267.34 492.094 1262.93 496.499 1262.93 501.933C1262.93 507.367 1267.34 511.772 1272.78 511.772Z",
    fill: "url(#paint108_linear_5175_27353)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 550.462C1350.32 550.462 1352.8 547.986 1352.8 544.907C1352.8 541.828 1350.32 539.352 1347.24 539.352C1344.16 539.352 1341.68 541.828 1341.68 544.907C1341.68 547.986 1344.16 550.462 1347.24 550.462Z",
    fill: "url(#paint109_linear_5175_27353)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 425.766C1278.16 425.766 1282.52 421.416 1282.52 416.028C1282.52 410.64 1278.16 406.289 1272.77 406.289C1267.38 406.289 1263.02 410.64 1263.02 416.028C1263.02 421.416 1267.38 425.766 1272.77 425.766Z",
    fill: "url(#paint110_linear_5175_27353)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 506.351C1424.15 506.351 1426.13 504.373 1426.13 501.933C1426.13 499.493 1424.15 497.516 1421.71 497.516C1419.27 497.516 1417.29 499.493 1417.29 501.933C1417.29 504.373 1419.27 506.351 1421.71 506.351Z",
    fill: "url(#paint111_linear_5175_27353)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M230.16 511.407C235.419 511.407 239.673 507.157 239.673 501.936C239.673 496.715 235.419 492.465 230.16 492.465C224.901 492.465 220.68 496.715 220.68 501.936C220.68 507.157 224.934 511.407 230.16 511.407Z",
    fill: "url(#paint112_linear_5175_27353)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M304.628 638.846C309.083 638.846 312.701 635.231 312.701 630.78C312.701 626.329 309.083 622.715 304.628 622.715C300.173 622.715 296.555 626.329 296.555 630.78C296.555 635.231 300.173 638.846 304.628 638.846Z",
    fill: "url(#paint113_linear_5175_27353)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M457.388 630.78C457.388 628.672 455.679 626.965 453.569 626.965C451.458 626.965 449.75 628.672 449.75 630.78C449.75 632.888 451.458 634.595 453.569 634.595C455.679 634.595 457.388 632.888 457.388 630.78Z",
    fill: "url(#paint114_linear_5175_27353)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M528.036 681.148C532.123 681.148 535.439 677.834 535.439 673.752C535.439 669.669 532.123 666.355 528.036 666.355C523.949 666.355 520.633 669.669 520.633 673.752C520.633 677.834 523.949 681.148 528.036 681.148Z",
    fill: "url(#paint115_linear_5175_27353)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M609.666 630.779C609.666 626.83 606.45 623.617 602.497 623.617C598.544 623.617 595.328 626.83 595.328 630.779C595.328 634.728 598.544 637.941 602.497 637.941C606.45 637.941 609.666 634.728 609.666 630.779Z",
    fill: "url(#paint116_linear_5175_27353)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M676.968 682.116C681.591 682.116 685.343 678.368 685.343 673.749C685.343 669.131 681.591 665.383 676.968 665.383C672.346 665.383 668.594 669.131 668.594 673.749C668.594 678.368 672.346 682.116 676.968 682.116Z",
    fill: "url(#paint117_linear_5175_27353)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M155.66 807.451C158.324 807.451 160.484 805.293 160.484 802.632C160.484 799.97 158.324 797.812 155.66 797.812C152.996 797.812 150.836 799.97 150.836 802.632C150.836 805.293 152.996 807.451 155.66 807.451Z",
    fill: "url(#paint118_linear_5175_27353)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1961 763.506C83.3237 763.506 85.0484 761.783 85.0484 759.657C85.0484 757.532 83.3237 755.809 81.1961 755.809C79.0685 755.809 77.3438 757.532 77.3438 759.657C77.3438 761.783 79.0685 763.506 81.1961 763.506Z",
    fill: "url(#paint119_linear_5175_27353)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3828 673.751C79.3828 674.755 80.1868 675.591 81.2252 675.591C82.2637 675.591 83.0677 674.788 83.0677 673.751C83.0677 672.713 82.2637 671.91 81.2252 671.91C80.1868 671.91 79.3828 672.713 79.3828 673.751Z",
    fill: "url(#paint120_linear_5175_27353)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M155.664 638.342C159.846 638.342 163.235 634.955 163.235 630.778C163.235 626.601 159.846 623.215 155.664 623.215C151.483 623.215 148.094 626.601 148.094 630.778C148.094 634.955 151.483 638.342 155.664 638.342Z",
    fill: "url(#paint121_linear_5175_27353)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M223.898 759.658C223.898 763.105 226.679 765.883 230.129 765.883C233.58 765.883 236.36 763.105 236.36 759.658C236.36 756.211 233.58 753.434 230.129 753.434C226.679 753.434 223.898 756.211 223.898 759.658Z",
    fill: "url(#paint122_linear_5175_27353)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M234.419 673.752C234.419 671.376 232.51 669.469 230.132 669.469C227.753 669.469 225.844 671.376 225.844 673.752C225.844 676.129 227.753 678.036 230.132 678.036C232.51 678.036 234.419 676.129 234.419 673.752Z",
    fill: "url(#paint123_linear_5175_27353)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M379.095 670.238C377.153 670.238 375.578 671.811 375.578 673.752C375.578 675.693 377.153 677.266 379.095 677.266C381.038 677.266 382.613 675.693 382.613 673.752C382.613 671.811 381.038 670.238 379.095 670.238Z",
    fill: "url(#paint124_linear_5175_27353)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M447.672 802.628C447.672 805.875 450.318 808.519 453.568 808.519C456.817 808.519 459.463 805.875 459.463 802.628C459.463 799.382 456.817 796.738 453.568 796.738C450.318 796.738 447.672 799.382 447.672 802.628Z",
    fill: "url(#paint125_linear_5175_27353)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M379.095 751.16C374.405 751.16 370.586 754.975 370.586 759.661C370.586 764.346 374.405 768.161 379.095 768.161C383.784 768.161 387.603 764.346 387.603 759.661C387.603 754.975 383.784 751.16 379.095 751.16Z",
    fill: "url(#paint126_linear_5175_27353)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M676.968 768.828C682.026 768.828 686.146 764.711 686.146 759.658C686.146 754.605 682.026 750.488 676.968 750.488C671.909 750.488 667.789 754.605 667.789 759.658C667.789 764.711 671.909 768.828 676.968 768.828Z",
    fill: "url(#paint127_linear_5175_27353)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.28 798.012C1195.73 798.012 1193.69 800.053 1193.69 802.597C1193.69 805.14 1195.73 807.181 1198.28 807.181C1200.82 807.181 1202.87 805.14 1202.87 802.597C1202.87 800.053 1200.82 798.012 1198.28 798.012Z",
    fill: "url(#paint128_linear_5175_27353)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.27 636.135C1201.22 636.135 1203.63 633.725 1203.63 630.78C1203.63 627.835 1201.22 625.426 1198.27 625.426C1195.33 625.426 1192.91 627.835 1192.91 630.78C1192.91 633.725 1195.33 636.135 1198.27 636.135Z",
    fill: "url(#paint129_linear_5175_27353)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 663.277C1266.98 663.277 1262.29 667.963 1262.29 673.752C1262.29 679.542 1266.98 684.227 1272.77 684.227C1278.57 684.227 1283.26 679.542 1283.26 673.752C1283.26 667.963 1278.57 663.277 1272.77 663.277Z",
    fill: "url(#paint130_linear_5175_27353)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 636.468C1350.39 636.468 1352.94 633.925 1352.94 630.779C1352.94 627.633 1350.39 625.09 1347.24 625.09C1344.09 625.09 1341.55 627.633 1341.55 630.779C1341.55 633.925 1344.09 636.468 1347.24 636.468Z",
    fill: "url(#paint131_linear_5175_27353)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 682.287C1426.44 682.287 1430.26 678.471 1430.26 673.753C1430.26 669.034 1426.44 665.219 1421.71 665.219C1416.99 665.219 1413.17 669.034 1413.17 673.753C1413.17 678.471 1416.99 682.287 1421.71 682.287Z",
    fill: "url(#paint132_linear_5175_27353)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.71 748.281C1415.41 748.281 1410.32 753.368 1410.32 759.66C1410.32 765.951 1415.41 771.038 1421.71 771.038C1428.01 771.038 1433.1 765.951 1433.1 759.66C1433.1 753.368 1428.01 748.281 1421.71 748.281Z",
    fill: "url(#paint133_linear_5175_27353)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M298.969 802.628C298.969 805.741 301.481 808.284 304.63 808.284C307.779 808.284 310.291 805.774 310.291 802.628C310.291 799.483 307.779 796.973 304.63 796.973C301.481 796.973 298.969 799.483 298.969 802.628Z",
    fill: "url(#paint134_linear_5175_27353)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M304.628 897.743C309.72 897.743 313.874 893.627 313.874 888.506C313.874 883.386 309.754 879.27 304.628 879.27C299.503 879.27 295.383 883.386 295.383 888.506C295.383 893.627 299.503 897.743 304.628 897.743Z",
    fill: "url(#paint135_linear_5175_27353)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M528.03 769.296C533.359 769.296 537.678 764.981 537.678 759.658C537.678 754.335 533.359 750.02 528.03 750.02C522.702 750.02 518.383 754.335 518.383 759.658C518.383 764.981 522.702 769.296 528.03 769.296Z",
    fill: "url(#paint136_linear_5175_27353)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M602.504 806.177C604.465 806.177 606.055 804.589 606.055 802.629C606.055 800.67 604.465 799.082 602.504 799.082C600.543 799.082 598.953 800.67 598.953 802.629C598.953 804.589 600.543 806.177 602.504 806.177Z",
    fill: "url(#paint137_linear_5175_27353)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M676.969 938.604C680.888 938.604 684.071 935.424 684.071 931.509C684.071 927.593 680.888 924.414 676.969 924.414C673.05 924.414 669.867 927.593 669.867 931.509C669.867 935.424 673.05 938.604 676.969 938.604Z",
    fill: "url(#paint138_linear_5175_27353)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M602.496 899.413C608.509 899.413 613.384 894.544 613.384 888.537C613.384 882.53 608.509 877.66 602.496 877.66C596.484 877.66 591.609 882.53 591.609 888.537C591.609 894.544 596.484 899.413 602.496 899.413Z",
    fill: "url(#paint139_linear_5175_27353)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.47 888.537C1204.47 885.123 1201.69 882.379 1198.27 882.379C1194.86 882.379 1192.11 885.157 1192.11 888.537C1192.11 891.917 1194.89 894.728 1198.27 894.728C1201.66 894.728 1204.47 891.95 1204.47 888.537Z",
    fill: "url(#paint140_linear_5175_27353)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 810.661C1351.7 810.661 1355.28 807.047 1355.28 802.63C1355.28 798.212 1351.66 794.598 1347.24 794.598C1342.82 794.598 1339.2 798.212 1339.2 802.63C1339.2 807.047 1342.82 810.661 1347.24 810.661Z",
    fill: "url(#paint141_linear_5175_27353)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.24 880.508C1342.79 880.508 1339.2 884.089 1339.2 888.54C1339.2 892.991 1342.79 896.572 1347.24 896.572C1351.7 896.572 1355.28 892.991 1355.28 888.54C1355.28 884.089 1351.7 880.508 1347.24 880.508Z",
    fill: "url(#paint142_linear_5175_27353)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6309 931.474C82.6309 930.704 81.9944 930.035 81.1904 930.035C80.3865 930.035 79.75 930.671 79.75 931.474C79.75 932.277 80.3865 932.913 81.1904 932.913C81.9944 932.913 82.6309 932.277 82.6309 931.474Z",
    fill: "url(#paint143_linear_5175_27353)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M155.664 883.887C153.085 883.887 151.008 885.962 151.008 888.539C151.008 891.116 153.085 893.19 155.664 893.19C158.244 893.19 160.32 891.116 160.32 888.539C160.32 885.962 158.244 883.887 155.664 883.887Z",
    fill: "url(#paint144_linear_5175_27353)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M230.163 919.629C223.631 919.629 218.305 924.917 218.305 931.476C218.305 938.035 223.597 943.323 230.163 943.323C236.729 943.323 242.022 938.035 242.022 931.476C242.022 924.917 236.729 919.629 230.163 919.629Z",
    fill: "url(#paint145_linear_5175_27353)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M379.098 924.312C375.146 924.312 371.93 927.525 371.93 931.474C371.93 935.423 375.146 938.636 379.098 938.636C383.051 938.636 386.267 935.423 386.267 931.474C386.267 927.525 383.051 924.312 379.098 924.312Z",
    fill: "url(#paint146_linear_5175_27353)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M453.562 896.671C458.051 896.671 461.702 893.023 461.702 888.539C461.702 884.054 458.051 880.406 453.562 880.406C449.073 880.406 445.422 884.054 445.422 888.539C445.422 893.023 449.073 896.671 453.562 896.671Z",
    fill: "url(#paint147_linear_5175_27353)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M537.344 931.476C537.344 926.322 533.157 922.172 528.031 922.172C522.906 922.172 518.719 926.355 518.719 931.476C518.719 936.596 522.906 940.779 528.031 940.779C533.157 940.779 537.344 936.596 537.344 931.476Z",
    fill: "url(#paint148_linear_5175_27353)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.8 937.866C1127.32 937.866 1130.2 934.988 1130.2 931.474C1130.2 927.96 1127.32 925.082 1123.8 925.082C1120.29 925.082 1117.41 927.96 1117.41 931.474C1117.41 934.988 1120.25 937.866 1123.8 937.866Z",
    fill: "url(#paint149_linear_5175_27353)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.77 938.537C1276.69 938.537 1279.84 935.358 1279.84 931.475C1279.84 927.593 1276.66 924.414 1272.77 924.414C1268.89 924.414 1265.7 927.593 1265.7 931.475C1265.7 935.358 1268.89 938.537 1272.77 938.537Z",
    fill: "url(#paint150_linear_5175_27353)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 149.299L1091.31 149.199L1000.23 96.6566V-8.66208L1000.43 -8.76249L1091.51 -61.3047L1091.71 -61.2043L1182.79 -8.66208V96.6566L1182.59 96.757L1091.51 149.299ZM1001 96.1881L1091.51 148.396L1182.02 96.1881V-8.22703L1091.51 -60.4346L1001 -8.22703V96.1881Z",
    fill: "url(#paint151_linear_5175_27353)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 149.299L1273.11 149.199L1182.02 96.6566V-8.66208L1182.22 -8.76249L1273.31 -61.3047L1273.51 -61.2043L1364.59 -8.66208V96.6566L1364.39 96.757L1273.31 149.299ZM1182.79 96.1881L1273.31 148.396L1363.82 96.1881V-8.22703L1273.31 -60.4346L1182.79 -8.22703V96.1881Z",
    fill: "url(#paint152_linear_5175_27353)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 129.15L1364.59 96.1854V-8.22969L1421.74 -41.1941V-42.0977L1363.99 -8.79861L1363.79 -8.66475V96.6205L1421.74 130.053V129.15Z",
    fill: "url(#paint153_linear_5175_27353)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.39 306.588L1182.19 306.488L1091.11 253.946V148.627L1091.31 148.527L1182.39 95.9844L1182.59 96.0848L1273.68 148.627V253.946L1273.48 254.046L1182.39 306.588ZM1091.91 253.477L1182.43 305.685L1272.94 253.477V149.062L1182.43 96.8545L1091.91 149.062V253.477Z",
    fill: "url(#paint154_linear_5175_27353)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 272.488L1364.19 305.653L1273.71 253.479V149.064L1364.19 96.8567L1421.74 130.055V129.152L1364.39 96.0535L1364.19 95.9531L1273.11 148.495L1272.91 148.596V253.914L1363.99 306.457L1364.19 306.59L1421.74 273.392V272.488Z",
    fill: "url(#paint155_linear_5175_27353)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0.963986 253.347L0.762995 253.246L-12 260.609V261.512L0.762995 254.15L91.2429 306.357V410.739L0.762995 462.946L-12 455.584V456.521L0.562002 463.75L0.762995 463.85L91.8459 411.308L92.0469 411.207V305.889L0.963986 253.347Z",
    fill: "url(#paint156_linear_5175_27353)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 463.85L1273.11 463.75L1182.02 411.207V305.889L1182.22 305.788L1273.31 253.246L1273.51 253.347L1364.59 305.889V411.207L1364.39 411.308L1273.31 463.85ZM1182.79 410.739L1273.31 462.946L1363.82 410.739V306.324L1273.31 254.116L1182.79 306.324V410.739Z",
    fill: "url(#paint157_linear_5175_27353)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 443.702L1364.59 410.738V306.356L1421.74 273.392V272.488L1363.99 305.787L1363.79 305.888V411.206L1421.74 444.639V443.702Z",
    fill: "url(#paint158_linear_5175_27353)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 455.582V456.519L0.361011 463.647V568.029L-12 575.157V576.094L0.963986 568.598L1.16498 568.498V463.179L-12 455.582Z",
    fill: "url(#paint159_linear_5175_27353)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6433 621.139L91.4423 621.039L0.359375 568.496V463.178L0.560367 463.077L91.6433 410.535L91.8443 410.636L182.927 463.178V568.496L182.726 568.597L91.6433 621.139ZM1.16334 568.028L91.6768 620.235L182.19 568.028V463.613L91.6768 411.405L1.16334 463.613V568.028Z",
    fill: "url(#paint160_linear_5175_27353)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M273.44 621.139L273.239 621.039L182.156 568.496V463.178L182.357 463.077L273.44 410.535L273.641 410.636L364.724 463.178V568.496L364.523 568.597L273.44 621.139ZM182.927 568.028L273.44 620.235L363.954 568.028V463.613L273.44 411.405L182.927 463.613V568.028Z",
    fill: "url(#paint161_linear_5175_27353)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M455.237 621.139L455.036 621.039L363.953 568.496V463.178L364.154 463.077L455.237 410.535L455.438 410.636L546.521 463.178V568.496L546.32 568.597L455.237 621.139ZM364.724 568.028L455.237 620.235L545.75 568.028V463.613L455.237 411.405L364.724 463.613V568.028Z",
    fill: "url(#paint162_linear_5175_27353)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0.963986 567.927L0.762995 567.793L-12 575.156V576.093L0.762995 568.73L91.2429 620.904V725.319L0.762995 777.527L-12 770.164V771.068L0.562002 778.33L0.762995 778.43L91.8459 725.888L92.0469 725.788V620.469L0.963986 567.927Z",
    fill: "url(#paint163_linear_5175_27353)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M182.557 778.432L182.356 778.332L91.2734 725.789V620.471L91.4744 620.37L182.557 567.828L182.758 567.929L273.841 620.471V725.789L273.64 725.89L182.557 778.432ZM92.0439 725.321L182.557 777.528L273.071 725.321V620.906L182.557 568.698L92.0439 620.906V725.321Z",
    fill: "url(#paint164_linear_5175_27353)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M364.323 778.432L364.122 778.332L273.039 725.789V620.471L273.24 620.37L364.323 567.828L364.524 567.929L455.607 620.471V725.789L455.406 725.89L364.323 778.432ZM273.843 725.321L364.356 777.528L454.87 725.321V620.906L364.356 568.698L273.843 620.906V725.321Z",
    fill: "url(#paint165_linear_5175_27353)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 770.164V771.068L0.361011 778.196V882.611L-12 889.739V890.643L0.963986 883.18L1.16498 883.08V777.761L-12 770.164Z",
    fill: "url(#paint166_linear_5175_27353)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6433 935.725L91.4423 935.625L0.359375 883.082V777.764L0.560367 777.663L91.6433 725.121L91.8443 725.221L182.927 777.764V883.082L182.726 883.183L91.6433 935.725ZM1.16334 882.614L91.6768 934.821L182.19 882.614V778.199L91.6768 725.991L1.16334 778.199V882.614Z",
    fill: "url(#paint167_linear_5175_27353)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M273.44 935.725L273.239 935.625L182.156 883.082V777.764L182.357 777.663L273.44 725.121L273.641 725.221L364.724 777.764V883.082L364.523 883.183L273.44 935.725ZM182.927 882.614L273.44 934.821L363.954 882.614V778.199L273.44 725.991L182.927 778.199V882.614Z",
    fill: "url(#paint168_linear_5175_27353)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M455.237 935.725L455.036 935.625L363.953 883.082V777.764L364.154 777.663L455.237 725.121L455.438 725.221L546.521 777.764V883.082L546.32 883.183L455.237 935.725ZM364.724 882.614L455.237 934.821L545.75 882.614V778.199L455.237 725.991L364.724 778.199V882.614Z",
    fill: "url(#paint169_linear_5175_27353)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.39 935.725L1182.19 935.625L1091.11 883.082V777.764L1091.31 777.663L1182.39 725.121L1182.59 725.221L1273.68 777.764V883.082L1273.48 883.183L1182.39 935.725ZM1091.91 882.614L1182.43 934.821L1272.94 882.614V778.199L1182.43 725.991L1091.91 778.199V882.614Z",
    fill: "url(#paint170_linear_5175_27353)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 901.621L1364.19 934.82L1273.71 882.612V778.197L1364.19 726.023L1421.74 759.188V758.285L1364.39 725.22L1364.19 725.086L1273.11 777.628L1272.91 777.762V883.081L1363.99 935.623L1364.19 935.723L1421.74 902.525V901.621Z",
    fill: "url(#paint171_linear_5175_27353)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0.963986 882.479L0.762995 882.379L-12 889.742V890.645L0.762995 883.283L91.2429 935.49V965.777H92.0469V935.022L0.963986 882.479Z",
    fill: "url(#paint172_linear_5175_27353)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0462 965.777V935.49L182.56 883.283L273.039 935.49V965.777H273.843V935.022L182.727 882.479L182.56 882.379L91.4432 934.921L91.2422 935.022V965.777H92.0462Z",
    fill: "url(#paint173_linear_5175_27353)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M273.843 965.777V935.49L364.323 883.283L454.836 935.49V965.777H455.64V935.022L364.524 882.479L364.323 882.379L273.24 934.921L273.039 935.022V965.777H273.843Z",
    fill: "url(#paint174_linear_5175_27353)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M455.64 965.777V935.49L546.12 883.283L636.633 935.49V965.777H637.437V935.022L546.321 882.479L546.12 882.379L455.037 934.921L454.836 935.022V965.777H455.64Z",
    fill: "url(#paint175_linear_5175_27353)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.79 965.777V935.49L1273.31 883.283L1363.79 935.49V965.777H1364.59V935.022L1273.51 882.479L1273.31 882.379L1182.22 934.921L1182.02 935.022V965.777H1182.79Z",
    fill: "url(#paint176_linear_5175_27353)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 901.621L1363.99 934.92L1363.79 935.021V965.776H1364.59V935.489L1421.74 902.525V901.621Z",
    fill: "url(#paint177_linear_5175_27353)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.62 -152V-45.1419L1184.21 21.9917L1067.8 -45.1419V-152H1063.68V-42.7658L1184.21 26.7439L1304.74 -42.7658V-152H1300.62Z",
    fill: "url(#paint178_linear_5175_27353)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.73 -45.1419V-152H1300.61V-42.7658L1421.14 26.7439L1421.74 26.4092V21.657L1421.14 21.9917L1304.73 -45.1419Z",
    fill: "url(#paint179_linear_5175_27353)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 15.332V20.0842L-2.48638 25.5727V159.84L-12 165.328V170.081L1.63396 162.216V23.1966L-12 15.332Z",
    fill: "url(#paint180_linear_5175_27353)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M118.044 231.726L-2.48438 162.216V23.1971L118.044 -46.3125L238.572 23.1971V162.216L118.044 231.726ZM1.63596 159.84L118.044 226.974L234.452 159.84V25.5398L118.044 -41.5937L1.63596 25.5733V159.874V159.84Z",
    fill: "url(#paint181_linear_5175_27353)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 21.6562L1419.06 23.1957V162.215L1421.74 163.754V21.6562Z",
    fill: "url(#paint182_linear_5175_27353)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.409459 158.668L-12 165.328V170.08L-0.409459 163.42L115.965 230.554V364.821L-0.409459 431.988L-12 425.295V430.047L-0.409459 436.707L120.085 367.197V228.178L-0.409459 158.668Z",
    fill: "url(#paint183_linear_5175_27353)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M236.497 436.707L115.969 367.197V228.178L236.497 158.668L357.025 228.178V367.197L236.497 436.707ZM120.089 364.821L236.497 431.954L352.905 364.821V230.52L236.497 163.387L120.089 230.52V364.821Z",
    fill: "url(#paint184_linear_5175_27353)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 425.293V430.045L-2.48638 435.534V569.834L-12 575.323V580.041L1.63396 572.177V433.158L-12 425.293Z",
    fill: "url(#paint185_linear_5175_27353)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M118.044 641.72L-2.48438 572.177V433.158L118.044 363.648L238.572 433.158V572.177L118.044 641.687V641.72ZM1.63596 569.835L118.044 636.968L234.452 569.835V435.534L118.044 368.401L1.63596 435.534V569.835Z",
    fill: "url(#paint186_linear_5175_27353)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 432.321L1302.65 363.648L1182.12 433.158V572.177L1302.65 641.687L1421.74 573.014V432.321ZM1302.65 636.968L1186.25 569.835V435.534L1302.65 368.401L1419.06 435.534V569.835L1302.65 636.968Z",
    fill: "url(#paint187_linear_5175_27353)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.409459 568.633L-12 575.326V580.045L-0.409459 573.385L115.965 640.519V774.819L-0.409459 841.953L-12 835.259V840.012L-0.409459 846.705L120.085 777.195V638.142L-0.409459 568.633Z",
    fill: "url(#paint188_linear_5175_27353)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M236.497 846.703L115.969 777.193V638.174L236.497 568.664L357.025 638.174V777.193L236.497 846.703ZM120.089 774.817L236.497 841.95L352.905 774.817V640.516L236.497 573.383L120.089 640.516V774.817Z",
    fill: "url(#paint189_linear_5175_27353)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.21 846.703L1063.68 777.193V638.174L1184.21 568.664L1304.74 638.174V777.193L1184.21 846.703ZM1067.8 774.817L1184.21 841.95L1300.62 774.817V640.516L1184.21 573.383L1067.8 640.516V774.817Z",
    fill: "url(#paint190_linear_5175_27353)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 841.585L1421.14 841.953L1304.73 774.819V640.519L1421.14 573.385L1421.74 573.72V569.001L1421.14 568.633L1300.61 638.142V777.195L1421.14 846.705L1421.74 846.337V841.585Z",
    fill: "url(#paint191_linear_5175_27353)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M-12 835.258V840.01L-2.48638 845.499V965.777H1.63396V843.122L-12 835.258Z",
    fill: "url(#paint192_linear_5175_27353)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63596 965.777V845.499L118.044 778.366L234.452 845.499V965.777H238.572V843.123L118.044 773.613L-2.48438 843.123V965.777H1.63596Z",
    fill: "url(#paint193_linear_5175_27353)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M238.573 965.777V845.499L354.981 778.366L471.389 845.499V965.777H475.476V843.123L354.981 773.613L234.453 843.123V965.777H238.573Z",
    fill: "url(#paint194_linear_5175_27353)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M475.47 965.777V845.499L591.878 778.366L708.285 845.499V965.777H712.406V843.123L591.878 773.613L471.383 843.123V965.777H475.47Z",
    fill: "url(#paint195_linear_5175_27353)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M712.409 965.777V845.499L828.817 778.366L945.225 845.499V965.777H949.346V843.123L828.817 773.613L708.289 843.123V965.777H712.409Z",
    fill: "url(#paint196_linear_5175_27353)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M949.347 965.777V845.499L1065.75 778.366L1182.16 845.499V965.777H1186.25V843.123L1065.75 773.613L945.227 843.123V965.777H949.347Z",
    fill: "url(#paint197_linear_5175_27353)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.75 965.777V842.286L1302.66 773.613L1182.16 843.123V965.777H1186.25V845.499L1302.66 778.366L1419.07 845.499V965.777H1421.75Z",
    fill: "url(#paint198_linear_5175_27353)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.74 841.582L1419.06 843.121V965.776H1421.74V841.582Z",
    fill: "url(#paint199_linear_5175_27353)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 1.37692C1369.62 1.37692 1374.01 -3.00717 1374.01 -8.42873C1374.01 -13.8503 1369.62 -18.2344 1364.19 -18.2344C1358.76 -18.2344 1354.38 -13.8503 1354.38 -8.42873C1354.38 -3.00717 1358.76 1.37692 1364.19 1.37692Z",
    fill: "url(#paint200_linear_5175_27353)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 88.0234C1359.53 88.0234 1355.78 91.7717 1355.78 96.4235C1355.78 101.075 1359.53 104.824 1364.19 104.824C1368.85 104.824 1372.6 101.075 1372.6 96.4235C1372.6 91.7717 1368.85 88.0234 1364.19 88.0234Z",
    fill: "url(#paint201_linear_5175_27353)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6797 306.121C85.6797 309.401 88.3596 312.078 91.6425 312.078C94.9253 312.078 97.6052 309.401 97.6052 306.121C97.6052 302.841 94.9253 300.164 91.6425 300.164C88.3596 300.164 85.6797 302.841 85.6797 306.121Z",
    fill: "url(#paint202_linear_5175_27353)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.63 106.129C1005.99 106.129 1010.34 101.784 1010.34 96.424C1010.34 91.0639 1005.99 86.7188 1000.63 86.7188C995.263 86.7188 990.914 91.0639 990.914 96.424C990.914 101.784 995.263 106.129 1000.63 106.129Z",
    fill: "url(#paint203_linear_5175_27353)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.43 148.831C1081.43 154.387 1085.95 158.905 1091.51 158.905C1097.07 158.905 1101.6 154.387 1101.6 148.831C1101.6 143.276 1097.07 138.758 1091.51 138.758C1085.95 138.758 1081.43 143.276 1081.43 148.831Z",
    fill: "url(#paint204_linear_5175_27353)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.39 312.213C1185.76 312.213 1188.49 309.486 1188.49 306.122C1188.49 302.758 1185.76 300.031 1182.39 300.031C1179.03 300.031 1176.3 302.758 1176.3 306.122C1176.3 309.486 1179.03 312.213 1182.39 312.213Z",
    fill: "url(#paint205_linear_5175_27353)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.51 245.75C1087.12 245.75 1083.57 249.297 1083.57 253.682C1083.57 258.066 1087.12 261.613 1091.51 261.613C1095.9 261.613 1099.45 258.066 1099.45 253.682C1099.45 249.297 1095.9 245.75 1091.51 245.75Z",
    fill: "url(#paint206_linear_5175_27353)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 104.887C1187.08 104.887 1190.87 101.096 1190.87 96.4201C1190.87 91.7439 1187.08 87.9531 1182.4 87.9531C1177.72 87.9531 1173.92 91.7439 1173.92 96.4201C1173.92 101.096 1177.72 104.887 1182.4 104.887Z",
    fill: "url(#paint207_linear_5175_27353)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 265.697C1279.95 265.697 1285.33 260.318 1285.33 253.682C1285.33 247.047 1279.95 241.668 1273.31 241.668C1266.67 241.668 1261.28 247.047 1261.28 253.682C1261.28 260.318 1266.67 265.697 1273.31 265.697Z",
    fill: "url(#paint208_linear_5175_27353)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 312.915C1367.94 312.915 1370.99 309.87 1370.99 306.122C1370.99 302.374 1367.94 299.328 1364.19 299.328C1360.44 299.328 1357.39 302.374 1357.39 306.122C1357.39 309.87 1360.44 312.915 1364.19 312.915Z",
    fill: "url(#paint209_linear_5175_27353)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 160.745C1279.88 160.745 1285.21 155.424 1285.21 148.865C1285.21 142.306 1279.88 136.984 1273.31 136.984C1266.75 136.984 1261.42 142.306 1261.42 148.865C1261.42 155.424 1266.75 160.745 1273.31 160.745Z",
    fill: "url(#paint210_linear_5175_27353)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0.762416 265.26C7.16066 265.26 12.353 260.073 12.353 253.681C12.353 247.289 7.16066 242.102 0.762416 242.102C-5.63583 242.102 -10.8281 247.289 -10.8281 253.681C-10.8281 260.073 -5.63583 265.26 0.762416 265.26Z",
    fill: "url(#paint211_linear_5175_27353)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6455 420.811C97.0723 420.811 101.494 416.393 101.494 410.972C101.494 405.55 97.0723 401.133 91.6455 401.133C86.2187 401.133 81.7969 405.55 81.7969 410.972C81.7969 416.393 86.2187 420.811 91.6455 420.811Z",
    fill: "url(#paint212_linear_5175_27353)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M278.13 410.974C278.13 408.397 276.019 406.289 273.44 406.289C270.86 406.289 268.75 408.397 268.75 410.974C268.75 413.551 270.86 415.66 273.44 415.66C276.019 415.66 278.13 413.551 278.13 410.974Z",
    fill: "url(#paint213_linear_5175_27353)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M364.326 472.451C369.321 472.451 373.371 468.405 373.371 463.415C373.371 458.424 369.321 454.379 364.326 454.379C359.331 454.379 355.281 458.424 355.281 463.415C355.281 468.405 359.331 472.451 364.326 472.451Z",
    fill: "url(#paint214_linear_5175_27353)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M463.986 410.973C463.986 406.154 460.067 402.238 455.243 402.238C450.419 402.238 446.5 406.154 446.5 410.973C446.5 415.792 450.419 419.708 455.243 419.708C460.067 419.708 463.986 415.792 463.986 410.973Z",
    fill: "url(#paint215_linear_5175_27353)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M546.123 473.622C551.766 473.622 556.34 469.052 556.34 463.414C556.34 457.777 551.766 453.207 546.123 453.207C540.481 453.207 535.906 457.777 535.906 463.414C535.906 469.052 540.481 473.622 546.123 473.622Z",
    fill: "url(#paint216_linear_5175_27353)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.875 568.265C-6.875 572.482 -3.45814 575.862 0.729198 575.862C4.91653 575.862 8.3334 572.448 8.3334 568.265C8.3334 564.082 4.91653 560.668 0.729198 560.668C-3.45814 560.668 -6.875 564.082 -6.875 568.265Z",
    fill: "url(#paint217_linear_5175_27353)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99065 463.416C5.99065 460.538 3.64574 458.195 0.764855 458.195C-2.11603 458.195 -4.46094 460.538 -4.46094 463.416C-4.46094 466.294 -2.11603 468.637 0.764855 468.637C3.64574 468.637 5.99065 466.294 5.99065 463.416Z",
    fill: "url(#paint218_linear_5175_27353)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M182.561 467.696C184.929 467.696 186.849 465.778 186.849 463.413C186.849 461.047 184.929 459.129 182.561 459.129C180.193 459.129 178.273 461.047 178.273 463.413C178.273 465.778 180.193 467.696 182.561 467.696Z",
    fill: "url(#paint219_linear_5175_27353)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M266.242 620.707C266.242 624.689 269.458 627.902 273.444 627.902C277.431 627.902 280.647 624.689 280.647 620.707C280.647 616.724 277.431 613.512 273.444 613.512C269.458 613.512 266.242 616.724 266.242 620.707Z",
    fill: "url(#paint220_linear_5175_27353)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M182.556 557.922C176.828 557.922 172.172 562.574 172.172 568.296C172.172 574.019 176.828 578.671 182.556 578.671C188.285 578.671 192.941 574.019 192.941 568.296C192.941 562.574 188.285 557.922 182.556 557.922Z",
    fill: "url(#paint221_linear_5175_27353)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M546.118 579.441C552.298 579.441 557.307 574.437 557.307 568.264C557.307 562.09 552.298 557.086 546.118 557.086C539.939 557.086 534.93 562.09 534.93 568.264C534.93 574.437 539.939 579.441 546.118 579.441Z",
    fill: "url(#paint222_linear_5175_27353)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.4 615.082C1179.32 615.082 1176.8 617.592 1176.8 620.671C1176.8 623.75 1179.32 626.26 1182.4 626.26C1185.48 626.26 1187.99 623.75 1187.99 620.671C1187.99 617.592 1185.48 615.082 1182.4 615.082Z",
    fill: "url(#paint223_linear_5175_27353)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.39 417.497C1186 417.497 1188.92 414.575 1188.92 410.971C1188.92 407.367 1186 404.445 1182.39 404.445C1178.78 404.445 1175.86 407.367 1175.86 410.971C1175.86 414.575 1178.78 417.497 1182.39 417.497Z",
    fill: "url(#paint224_linear_5175_27353)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 476.197C1280.38 476.197 1286.11 470.474 1286.11 463.413C1286.11 456.353 1280.38 450.629 1273.31 450.629C1266.24 450.629 1260.52 456.353 1260.52 463.413C1260.52 470.474 1266.24 476.197 1273.31 476.197Z",
    fill: "url(#paint225_linear_5175_27353)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 417.933C1368.04 417.933 1371.13 414.821 1371.13 411.006C1371.13 407.19 1368.01 404.078 1364.19 404.078C1360.37 404.078 1357.26 407.19 1357.26 411.006C1357.26 414.821 1360.37 417.933 1364.19 417.933Z",
    fill: "url(#paint226_linear_5175_27353)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6429 627.601C95.4541 627.601 98.5436 624.514 98.5436 620.707C98.5436 616.899 95.4541 613.812 91.6429 613.812C87.8318 613.812 84.7422 616.899 84.7422 620.707C84.7422 624.514 87.8318 627.601 91.6429 627.601Z",
    fill: "url(#paint227_linear_5175_27353)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6484 736.802C97.8792 736.802 102.937 731.749 102.937 725.524C102.937 719.299 97.8792 714.246 91.6484 714.246C85.4177 714.246 80.3594 719.299 80.3594 725.524C80.3594 731.749 85.4177 736.802 91.6484 736.802Z",
    fill: "url(#paint228_linear_5175_27353)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M364.323 580.045C370.835 580.045 376.114 574.771 376.114 568.265C376.114 561.759 370.835 556.484 364.323 556.484C357.81 556.484 352.531 561.759 352.531 568.265C352.531 574.771 357.81 580.045 364.323 580.045Z",
    fill: "url(#paint229_linear_5175_27353)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M450.922 620.708C450.922 623.084 452.865 625.025 455.243 625.025C457.622 625.025 459.565 623.084 459.565 620.708C459.565 618.332 457.622 616.391 455.243 616.391C452.865 616.391 450.922 618.332 450.922 620.708Z",
    fill: "url(#paint230_linear_5175_27353)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M546.121 786.668C550.913 786.668 554.798 782.787 554.798 778C554.798 773.213 550.913 769.332 546.121 769.332C541.33 769.332 537.445 773.213 537.445 778C537.445 782.787 541.33 786.668 546.121 786.668Z",
    fill: "url(#paint231_linear_5175_27353)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M455.242 712.27C447.906 712.27 441.977 718.227 441.977 725.522C441.977 732.818 447.939 738.775 455.242 738.775C462.545 738.775 468.508 732.818 468.508 725.522C468.508 718.227 462.545 712.27 455.242 712.27Z",
    fill: "url(#paint232_linear_5175_27353)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.97 725.557C1189.97 721.407 1186.58 718.027 1182.43 718.027C1178.27 718.027 1174.89 721.407 1174.89 725.557C1174.89 729.707 1178.27 733.087 1182.43 733.087C1186.58 733.087 1189.97 729.707 1189.97 725.557Z",
    fill: "url(#paint233_linear_5175_27353)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 630.514C1369.62 630.514 1374.01 626.13 1374.01 620.708C1374.01 615.286 1369.62 610.902 1364.19 610.902C1358.76 610.902 1354.38 615.286 1354.38 620.708C1354.38 626.13 1358.76 630.514 1364.19 630.514Z",
    fill: "url(#paint234_linear_5175_27353)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 715.75C1358.76 715.75 1354.38 720.134 1354.38 725.556C1354.38 730.977 1358.76 735.361 1364.19 735.361C1369.62 735.361 1374.01 730.977 1374.01 725.556C1374.01 720.134 1369.62 715.75 1364.19 715.75Z",
    fill: "url(#paint235_linear_5175_27353)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0.762993 763.541C-4.79779 763.541 -9.5546 766.721 -12 771.306V784.659C-9.5881 789.243 -4.79779 792.423 0.762993 792.423C8.73568 792.423 15.2344 785.964 15.2344 777.965C15.2344 769.967 8.76917 763.508 0.762993 763.508V763.541Z",
    fill: "url(#paint236_linear_5175_27353)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6448 941.516C95.0952 941.516 97.8756 938.738 97.8756 935.291C97.8756 931.844 95.0952 929.066 91.6448 929.066C88.1945 929.066 85.4141 931.844 85.4141 935.291C85.4141 938.738 88.1945 941.516 91.6448 941.516Z",
    fill: "url(#paint237_linear_5175_27353)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M182.562 895.162C189.362 895.162 194.889 889.641 194.889 882.847C194.889 876.053 189.362 870.531 182.562 870.531C175.762 870.531 170.234 876.053 170.234 882.847C170.234 889.641 175.762 895.162 182.562 895.162Z",
    fill: "url(#paint238_linear_5175_27353)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M182.563 769.262C177.74 769.262 173.82 773.177 173.82 777.996C173.82 782.816 177.74 786.731 182.563 786.731C187.387 786.731 191.307 782.816 191.307 777.996C191.307 773.177 187.387 769.262 182.563 769.262Z",
    fill: "url(#paint239_linear_5175_27353)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M273.441 735.496C278.935 735.496 283.39 731.045 283.39 725.557C283.39 720.068 278.935 715.617 273.441 715.617C267.948 715.617 263.492 720.068 263.492 725.557C263.492 731.045 267.948 735.496 273.441 735.496Z",
    fill: "url(#paint240_linear_5175_27353)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M375.712 777.997C375.712 771.739 370.62 766.652 364.356 766.652C358.092 766.652 353 771.739 353 777.997C353 784.256 358.092 789.343 364.356 789.343C370.62 789.343 375.712 784.256 375.712 777.997Z",
    fill: "url(#paint241_linear_5175_27353)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M455.241 944.191C460.165 944.191 464.185 940.209 464.185 935.256C464.185 930.303 460.199 926.32 455.241 926.32C450.283 926.32 446.297 930.303 446.297 935.256C446.297 940.209 450.283 944.191 455.241 944.191Z",
    fill: "url(#paint242_linear_5175_27353)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M546.119 892.285C551.336 892.285 555.565 888.06 555.565 882.848C555.565 877.636 551.336 873.41 546.119 873.41C540.901 873.41 536.672 877.636 536.672 882.848C536.672 888.06 540.901 892.285 546.119 892.285Z",
    fill: "url(#paint243_linear_5175_27353)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.52 785.795C1095.84 785.795 1099.32 782.314 1099.32 777.997C1099.32 773.68 1095.84 770.199 1091.52 770.199C1087.19 770.199 1083.71 773.68 1083.71 777.997C1083.71 782.314 1087.19 785.795 1091.52 785.795Z",
    fill: "url(#paint244_linear_5175_27353)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 786.632C1278.08 786.632 1281.95 782.766 1281.95 777.998C1281.95 773.229 1278.08 769.363 1273.31 769.363C1268.53 769.363 1264.66 773.229 1264.66 777.998C1264.66 782.766 1268.53 786.632 1273.31 786.632Z",
    fill: "url(#paint245_linear_5175_27353)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0.760126 878.164C-1.81927 878.164 -3.92969 880.272 -3.92969 882.849C-3.92969 885.426 -1.81927 887.535 0.760126 887.535C3.33952 887.535 5.44994 885.426 5.44994 882.849C5.44994 880.272 3.33952 878.164 0.760126 878.164Z",
    fill: "url(#paint246_linear_5175_27353)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M273.44 923.477C266.941 923.477 261.648 928.764 261.648 935.257C261.648 941.749 266.941 947.037 273.44 947.037C279.939 947.037 285.232 941.749 285.232 935.257C285.232 928.764 279.939 923.477 273.44 923.477Z",
    fill: "url(#paint247_linear_5175_27353)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M364.322 888.102C367.226 888.102 369.581 885.75 369.581 882.848C369.581 879.946 367.226 877.594 364.322 877.594C361.417 877.594 359.062 879.946 359.062 882.848C359.062 885.75 361.417 888.102 364.322 888.102Z",
    fill: "url(#paint248_linear_5175_27353)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M637.038 942.219C640.886 942.219 644.006 939.102 644.006 935.258C644.006 931.413 640.886 928.297 637.038 928.297C633.19 928.297 630.07 931.413 630.07 935.258C630.07 939.102 633.19 942.219 637.038 942.219Z",
    fill: "url(#paint249_linear_5175_27353)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.52 874.113C1086.69 874.113 1082.77 878.029 1082.77 882.848C1082.77 887.667 1086.69 891.583 1091.52 891.583C1096.34 891.583 1100.26 887.667 1100.26 882.848C1100.26 878.029 1096.34 874.113 1091.52 874.113Z",
    fill: "url(#paint250_linear_5175_27353)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.54 935.257C1177.54 937.934 1179.72 940.143 1182.43 940.143C1185.14 940.143 1187.32 937.968 1187.32 935.257C1187.32 932.546 1185.14 930.371 1182.43 930.371C1179.72 930.371 1177.54 932.546 1177.54 935.257Z",
    fill: "url(#paint251_linear_5175_27353)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.31 873.777C1268.29 873.777 1264.23 877.827 1264.23 882.847C1264.23 887.867 1268.29 891.916 1273.31 891.916C1278.34 891.916 1282.39 887.867 1282.39 882.847C1282.39 877.827 1278.34 873.777 1273.31 873.777Z",
    fill: "url(#paint252_linear_5175_27353)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 924.516C1358.26 924.516 1353.44 929.335 1353.44 935.258C1353.44 941.182 1358.26 946.001 1364.19 946.001C1370.12 946.001 1374.94 941.182 1374.94 935.258C1374.94 929.335 1370.12 924.516 1364.19 924.516Z",
    fill: "url(#paint253_linear_5175_27353)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5175_27353",
    x1: 897.029,
    y1: 7.91492,
    x2: 722.834,
    y2: 90.9861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5175_27353",
    x1: 1045.97,
    y1: 7.91492,
    x2: 871.771,
    y2: 90.9861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5175_27353",
    x1: 1194.9,
    y1: 7.91492,
    x2: 1020.71,
    y2: 90.9861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5175_27353",
    x1: 1343.87,
    y1: 7.91492,
    x2: 1169.68,
    y2: 90.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5175_27353",
    x1: 1437.69,
    y1: 7.88399,
    x2: 1315.41,
    y2: 44.1634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5175_27353",
    x1: 226.755,
    y1: 136.759,
    x2: 52.5604,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5175_27353",
    x1: 971.497,
    y1: 136.759,
    x2: 797.303,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5175_27353",
    x1: 1120.43,
    y1: 136.759,
    x2: 946.24,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5175_27353",
    x1: 1269.36,
    y1: 136.759,
    x2: 1095.17,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5175_27353",
    x1: 1418.33,
    y1: 136.759,
    x2: 1244.14,
    y2: 219.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5175_27353",
    x1: 1439.54,
    y1: 160.968,
    x2: 1413.16,
    y2: 163.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5175_27353",
    x1: 1194.9,
    y1: 265.638,
    x2: 1020.71,
    y2: 348.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5175_27353",
    x1: 1343.87,
    y1: 265.638,
    x2: 1169.68,
    y2: 348.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5175_27353",
    x1: 1437.69,
    y1: 265.607,
    x2: 1315.41,
    y2: 301.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5175_27353",
    x1: 1269.36,
    y1: 394.485,
    x2: 1095.17,
    y2: 477.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5175_27353",
    x1: 1418.33,
    y1: 394.485,
    x2: 1244.14,
    y2: 477.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5175_27353",
    x1: 1439.54,
    y1: 418.695,
    x2: 1413.16,
    y2: 421.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5175_27353",
    x1: 301.255,
    y1: 523.364,
    x2: 127.06,
    y2: 606.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5175_27353",
    x1: 1343.87,
    y1: 523.364,
    x2: 1169.68,
    y2: 606.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5175_27353",
    x1: 1437.69,
    y1: 523.364,
    x2: 1315.41,
    y2: 559.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5175_27353",
    x1: 226.755,
    y1: 652.243,
    x2: 52.5604,
    y2: 735.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5175_27353",
    x1: 375.724,
    y1: 652.243,
    x2: 201.529,
    y2: 735.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5175_27353",
    x1: 524.661,
    y1: 652.243,
    x2: 350.467,
    y2: 735.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5175_27353",
    x1: 673.591,
    y1: 652.243,
    x2: 499.396,
    y2: 735.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5175_27353",
    x1: 1439.54,
    y1: 676.449,
    x2: 1413.16,
    y2: 678.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5175_27353",
    x1: 301.255,
    y1: 781.087,
    x2: 127.06,
    y2: 864.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5175_27353",
    x1: 450.193,
    y1: 781.087,
    x2: 275.998,
    y2: 864.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5175_27353",
    x1: 599.13,
    y1: 781.087,
    x2: 424.935,
    y2: 864.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5175_27353",
    x1: 226.754,
    y1: 899.738,
    x2: 108.129,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5175_27353",
    x1: 375.691,
    y1: 899.738,
    x2: 257.066,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5175_27353",
    x1: 524.661,
    y1: 899.738,
    x2: 406.034,
    y2: 1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5175_27353",
    x1: 673.591,
    y1: 899.738,
    x2: 554.963,
    y2: 1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5175_27353",
    x1: 1269.37,
    y1: 899.738,
    x2: 1150.75,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5175_27353",
    x1: 1418.3,
    y1: 899.738,
    x2: 1299.68,
    y2: 1005.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5175_27353",
    x1: 1196.56,
    y1: -51.0307,
    x2: 966.572,
    y2: 58.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5175_27353",
    x1: 1390.68,
    y1: -51.0307,
    x2: 1160.7,
    y2: 58.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5175_27353",
    x1: 1438.81,
    y1: -29.0407,
    x2: 1372.11,
    y2: -18.6652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5175_27353",
    x1: 1293.6,
    y1: 116.938,
    x2: 1063.62,
    y2: 226.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5175_27353",
    x1: 1436.41,
    y1: 116.965,
    x2: 1251.92,
    y2: 181.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5175_27353",
    x1: 35.5321,
    y1: 306.435,
    x2: -32.4393,
    y2: 317.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5175_27353",
    x1: 225.971,
    y1: 284.872,
    x2: -4.01416,
    y2: 394.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5175_27353",
    x1: 420.096,
    y1: 284.872,
    x2: 190.111,
    y2: 394.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5175_27353",
    x1: 1438.81,
    y1: 306.862,
    x2: 1372.11,
    y2: 317.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5175_27353",
    x1: 130.204,
    y1: 452.836,
    x2: -55.2178,
    y2: 518.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5175_27353",
    x1: 323.049,
    y1: 452.836,
    x2: 93.064,
    y2: 562.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5175_27353",
    x1: 517.143,
    y1: 452.836,
    x2: 287.158,
    y2: 562.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5175_27353",
    x1: 35.5321,
    y1: 642.333,
    x2: -32.4386,
    y2: 653.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5175_27353",
    x1: 225.971,
    y1: 620.774,
    x2: -4.01418,
    y2: 730.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5175_27353",
    x1: 420.096,
    y1: 620.774,
    x2: 190.111,
    y2: 730.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5175_27353",
    x1: 1390.68,
    y1: 620.774,
    x2: 1160.7,
    y2: 730.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5175_27353",
    x1: 27.3324,
    y1: 959.676,
    x2: -2.85114,
    y2: 988.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5175_27353",
    x1: 130.204,
    y1: 787.754,
    x2: -53.7547,
    y2: 854.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5175_27353",
    x1: 323.016,
    y1: 787.754,
    x2: 96.0871,
    y2: 899.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5175_27353",
    x1: 517.141,
    y1: 787.754,
    x2: 290.212,
    y2: 899.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5175_27353",
    x1: 1293.6,
    y1: 787.754,
    x2: 1066.67,
    y2: 899.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5175_27353",
    x1: 1436.41,
    y1: 787.754,
    x2: 1253.36,
    y2: 854.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5175_27353",
    x1: 1439.02,
    y1: 960.144,
    x2: 1409.53,
    y2: 988.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5175_27353",
    x1: 27.3324,
    y1: 959.68,
    x2: -2.85114,
    y2: 988.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5175_27353",
    x1: 217.976,
    y1: 934.477,
    x2: 162.291,
    y2: 1040.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5175_27353",
    x1: 412.068,
    y1: 934.477,
    x2: 356.378,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5175_27353",
    x1: 606.193,
    y1: 934.477,
    x2: 550.503,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5175_27353",
    x1: 800.32,
    y1: 934.477,
    x2: 744.635,
    y2: 1040.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5175_27353",
    x1: 994.412,
    y1: 934.477,
    x2: 938.721,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_5175_27353",
    x1: 1188.54,
    y1: 934.477,
    x2: 1132.85,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_5175_27353",
    x1: 1382.66,
    y1: 934.477,
    x2: 1326.97,
    y2: 1040.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_5175_27353",
    x1: 1439.03,
    y1: 960.148,
    x2: 1409.54,
    y2: 988.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_5175_27353",
    x1: 235.258,
    y1: 154.267,
    x2: 223.502,
    y2: 160.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_5175_27353",
    x1: 761.246,
    y1: 21.7442,
    x2: 738.688,
    y2: 34.1637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_5175_27353",
    x1: 757.584,
    y1: 110.53,
    x2: 743.476,
    y2: 118.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_5175_27353",
    x1: 831.444,
    y1: 153.943,
    x2: 818.732,
    y2: 160.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_5175_27353",
    x1: 906.007,
    y1: 25.0194,
    x2: 893.075,
    y2: 32.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_5175_27353",
    x1: 910.244,
    y1: 107.601,
    x2: 887.539,
    y2: 120.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_5175_27353",
    x1: 1056.98,
    y1: 23.4199,
    x2: 1039.34,
    y2: 33.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_5175_27353",
    x1: 1058.44,
    y1: 108.176,
    x2: 1037.43,
    y2: 119.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_5175_27353",
    x1: 1203.75,
    y1: 25.1223,
    x2: 1191.12,
    y2: 32.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_5175_27353",
    x1: 1202.19,
    y1: 112.255,
    x2: 1193.15,
    y2: 117.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_5175_27353",
    x1: 1353.04,
    y1: 24.8709,
    x2: 1339.67,
    y2: 32.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_5175_27353",
    x1: 1353.83,
    y1: 110.153,
    x2: 1338.62,
    y2: 118.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_5175_27353",
    x1: 162.189,
    y1: 282.045,
    x2: 147.18,
    y2: 290.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_5175_27353",
    x1: 85.3034,
    y1: 240.985,
    x2: 75.8248,
    y2: 246.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_5175_27353",
    x1: 84.317,
    y1: 155.817,
    x2: 77.1162,
    y2: 159.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_5175_27353",
    x1: 165.184,
    y1: 107.852,
    x2: 143.214,
    y2: 119.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_5175_27353",
    x1: 238.157,
    y1: 237.931,
    x2: 219.714,
    y2: 248.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_5175_27353",
    x1: 833.322,
    y1: 238.376,
    x2: 816.275,
    y2: 247.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_5175_27353",
    x1: 978.658,
    y1: 155.326,
    x2: 969.914,
    y2: 160.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_5175_27353",
    x1: 981.874,
    y1: 238.708,
    x2: 965.709,
    y2: 247.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_5175_27353",
    x1: 1053.76,
    y1: 283.671,
    x2: 1043.55,
    y2: 289.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_5175_27353",
    x1: 1134.16,
    y1: 150.174,
    x2: 1110.28,
    y2: 163.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_5175_27353",
    x1: 1280.45,
    y1: 152.276,
    x2: 1262.74,
    y2: 162.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_5175_27353",
    x1: 1354.88,
    y1: 281.146,
    x2: 1337.25,
    y2: 290.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_5175_27353",
    x1: 1281.79,
    y1: 237.131,
    x2: 1260.99,
    y2: 248.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_5175_27353",
    x1: 1429.93,
    y1: 151.814,
    x2: 1410.97,
    y2: 162.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_5175_27353",
    x1: 906.29,
    y1: 282.521,
    x2: 892.697,
    y2: 290.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_5175_27353",
    x1: 1128.55,
    y1: 240.482,
    x2: 1117.6,
    y2: 246.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_5175_27353",
    x1: 1203.37,
    y1: 283.146,
    x2: 1191.61,
    y2: 289.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_5175_27353",
    x1: 1426.74,
    y1: 412.074,
    x2: 1415.13,
    y2: 418.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_5175_27353",
    x1: 1353.8,
    y1: 367.902,
    x2: 1338.67,
    y2: 376.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_5175_27353",
    x1: 1427.98,
    y1: 239.283,
    x2: 1413.51,
    y2: 247.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_5175_27353",
    x1: 163.109,
    y1: 539.018,
    x2: 145.915,
    y2: 548.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_5175_27353",
    x1: 81.8642,
    y1: 501.408,
    x2: 80.3212,
    y2: 502.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_5175_27353",
    x1: 87.1476,
    y1: 411.351,
    x2: 73.4073,
    y2: 418.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_5175_27353",
    x1: 160.785,
    y1: 369.029,
    x2: 148.955,
    y2: 375.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_5175_27353",
    x1: 309.281,
    y1: 541.219,
    x2: 298.554,
    y2: 547.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_5175_27353",
    x1: 1056.92,
    y1: 367.137,
    x2: 1039.43,
    y2: 376.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_5175_27353",
    x1: 1131.67,
    y1: 409.85,
    x2: 1113.52,
    y2: 419.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_5175_27353",
    x1: 1203.02,
    y1: 541.147,
    x2: 1192.07,
    y2: 547.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_5175_27353",
    x1: 1129.98,
    y1: 497.082,
    x2: 1115.73,
    y2: 504.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_5175_27353",
    x1: 1204.87,
    y1: 367.879,
    x2: 1189.66,
    y2: 376.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_5175_27353",
    x1: 1282.14,
    y1: 494.58,
    x2: 1260.54,
    y2: 506.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_5175_27353",
    x1: 1352.53,
    y1: 540.755,
    x2: 1340.33,
    y2: 547.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_5175_27353",
    x1: 1282.04,
    y1: 408.75,
    x2: 1260.65,
    y2: 420.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_5175_27353",
    x1: 1425.91,
    y1: 498.632,
    x2: 1416.21,
    y2: 503.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_5175_27353",
    x1: 239.203,
    y1: 494.858,
    x2: 218.389,
    y2: 506.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_5175_27353",
    x1: 312.301,
    y1: 624.753,
    x2: 294.593,
    y2: 634.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_5175_27353",
    x1: 457.198,
    y1: 627.929,
    x2: 448.822,
    y2: 632.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_5175_27353",
    x1: 535.072,
    y1: 668.224,
    x2: 518.834,
    y2: 677.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_5175_27353",
    x1: 609.31,
    y1: 625.427,
    x2: 593.586,
    y2: 634.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_5175_27353",
    x1: 684.928,
    y1: 667.497,
    x2: 666.558,
    y2: 677.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_5175_27353",
    x1: 160.244,
    y1: 799.03,
    x2: 149.664,
    y2: 804.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_5175_27353",
    x1: 84.8574,
    y1: 756.781,
    x2: 76.4075,
    y2: 761.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_5175_27353",
    x1: 82.9763,
    y1: 672.375,
    x2: 78.9351,
    y2: 674.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_5175_27353",
    x1: 162.86,
    y1: 625.126,
    x2: 146.254,
    y2: 634.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_5175_27353",
    x1: 236.051,
    y1: 755.006,
    x2: 222.384,
    y2: 762.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_5175_27353",
    x1: 234.207,
    y1: 670.551,
    x2: 224.802,
    y2: 675.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_5175_27353",
    x1: 382.438,
    y1: 671.126,
    x2: 374.723,
    y2: 675.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_5175_27353",
    x1: 459.171,
    y1: 798.226,
    x2: 446.239,
    y2: 805.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_5175_27353",
    x1: 387.181,
    y1: 753.308,
    x2: 368.518,
    y2: 763.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_5175_27353",
    x1: 685.691,
    y1: 752.805,
    x2: 665.558,
    y2: 763.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_5175_27353",
    x1: 1202.64,
    y1: 799.17,
    x2: 1192.57,
    y2: 804.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_5175_27353",
    x1: 1203.37,
    y1: 626.779,
    x2: 1191.61,
    y2: 633.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_5175_27353",
    x1: 1282.74,
    y1: 665.924,
    x2: 1259.74,
    y2: 678.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_5175_27353",
    x1: 1352.65,
    y1: 626.527,
    x2: 1340.16,
    y2: 633.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_5175_27353",
    x1: 1429.83,
    y1: 667.375,
    x2: 1411.1,
    y2: 677.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_5175_27353",
    x1: 1432.53,
    y1: 751.156,
    x2: 1407.55,
    y2: 764.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_5175_27353",
    x1: 310.011,
    y1: 798.402,
    x2: 297.593,
    y2: 805.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_5175_27353",
    x1: 313.416,
    y1: 881.603,
    x2: 293.136,
    y2: 892.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_5175_27353",
    x1: 537.2,
    y1: 752.455,
    x2: 516.038,
    y2: 764.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_5175_27353",
    x1: 605.879,
    y1: 799.978,
    x2: 598.09,
    y2: 804.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_5175_27353",
    x1: 683.718,
    y1: 926.207,
    x2: 668.141,
    y2: 934.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_5175_27353",
    x1: 612.844,
    y1: 880.408,
    x2: 588.963,
    y2: 893.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_5175_27353",
    x1: 1204.16,
    y1: 883.939,
    x2: 1190.61,
    y2: 891.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_5175_27353",
    x1: 1354.88,
    y1: 796.627,
    x2: 1337.25,
    y2: 806.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_5175_27353",
    x1: 1354.88,
    y1: 882.537,
    x2: 1337.25,
    y2: 892.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_5175_27353",
    x1: 82.5595,
    y1: 930.399,
    x2: 79.4,
    y2: 932.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_5175_27353",
    x1: 160.09,
    y1: 885.062,
    x2: 149.876,
    y2: 890.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_5175_27353",
    x1: 241.434,
    y1: 922.622,
    x2: 215.423,
    y2: 936.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_5175_27353",
    x1: 385.912,
    y1: 926.122,
    x2: 370.187,
    y2: 934.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_5175_27353",
    x1: 461.299,
    y1: 882.461,
    x2: 443.444,
    y2: 892.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_5175_27353",
    x1: 536.882,
    y1: 924.522,
    x2: 516.455,
    y2: 935.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_5175_27353",
    x1: 1129.89,
    y1: 926.697,
    x2: 1115.85,
    y2: 934.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_5175_27353",
    x1: 1279.49,
    y1: 926.198,
    x2: 1263.99,
    y2: 934.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_5175_27353",
    x1: 1178.27,
    y1: -34.7001,
    x2: 965.68,
    y2: 66.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_5175_27353",
    x1: 1360.06,
    y1: -34.7001,
    x2: 1147.48,
    y2: 66.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_5175_27353",
    x1: 1420.3,
    y1: -20.3507,
    x2: 1340.23,
    y2: -5.52311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_5175_27353",
    x1: 1269.15,
    y1: 122.589,
    x2: 1056.56,
    y2: 223.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_5175_27353",
    x1: 1418.05,
    y1: 122.562,
    x2: 1233.25,
    y2: 194.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_5175_27353",
    x1: 89.4672,
    y1: 279.851,
    x2: -49.0076,
    y2: 317.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_5175_27353",
    x1: 1360.06,
    y1: 279.851,
    x2: 1147.48,
    y2: 381.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_5175_27353",
    x1: 1420.3,
    y1: 294.235,
    x2: 1340.23,
    y2: 309.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_5175_27353",
    x1: 0.838575,
    y1: 470.806,
    x2: -17.9087,
    y2: 471.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_5175_27353",
    x1: 178.401,
    y1: 437.14,
    x2: -34.1869,
    y2: 538.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_5175_27353",
    x1: 360.198,
    y1: 437.14,
    x2: 147.61,
    y2: 538.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_5175_27353",
    x1: 541.994,
    y1: 437.14,
    x2: 329.407,
    y2: 538.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_5175_27353",
    x1: 89.4672,
    y1: 594.402,
    x2: -49.0106,
    y2: 632.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_5175_27353",
    x1: 269.315,
    y1: 594.433,
    x2: 56.7272,
    y2: 695.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_5175_27353",
    x1: 451.08,
    y1: 594.433,
    x2: 238.493,
    y2: 695.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_5175_27353",
    x1: 0.838575,
    y1: 785.384,
    x2: -17.9086,
    y2: 786.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_5175_27353",
    x1: 178.401,
    y1: 751.726,
    x2: -34.1869,
    y2: 853.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_5175_27353",
    x1: 360.198,
    y1: 751.726,
    x2: 147.61,
    y2: 853.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_5175_27353",
    x1: 541.994,
    y1: 751.726,
    x2: 329.407,
    y2: 853.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_5175_27353",
    x1: 1269.15,
    y1: 751.726,
    x2: 1056.56,
    y2: 853.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_5175_27353",
    x1: 1418.05,
    y1: 751.695,
    x2: 1233.25,
    y2: 823.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_5175_27353",
    x1: 89.4672,
    y1: 892.914,
    x2: -11.6278,
    y2: 962.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_5175_27353",
    x1: 269.316,
    y1: 892.914,
    x2: 162.814,
    y2: 1021.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_5175_27353",
    x1: 451.113,
    y1: 892.914,
    x2: 344.611,
    y2: 1021.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_5175_27353",
    x1: 632.91,
    y1: 892.914,
    x2: 526.408,
    y2: 1021.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_5175_27353",
    x1: 1360.06,
    y1: 892.914,
    x2: 1253.56,
    y2: 1021.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_5175_27353",
    x1: 1420.3,
    y1: 909.725,
    x2: 1353.88,
    y2: 942.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_5175_27353",
    x1: 1298.76,
    y1: -129.42,
    x2: 1076.53,
    y2: 35.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_5175_27353",
    x1: 1418.74,
    y1: -129.42,
    x2: 1266.74,
    y2: -72.7633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_5175_27353",
    x1: 1.29593,
    y1: 34.8807,
    x2: -18.1436,
    y2: 35.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_5175_27353",
    x1: 232.596,
    y1: -11.1892,
    x2: -48.0847,
    y2: 122.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_5175_27353",
    x1: 1421.68,
    y1: 39.6068,
    x2: 1417.85,
    y2: 39.6465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_5175_27353",
    x1: 116.81,
    y1: 193.791,
    x2: -59.8961,
    y2: 239.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_5175_27353",
    x1: 351.049,
    y1: 193.791,
    x2: 70.3684,
    y2: 327.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_5175_27353",
    x1: 1.29593,
    y1: 444.842,
    x2: -18.1436,
    y2: 445.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_5175_27353",
    x1: 232.596,
    y1: 398.776,
    x2: -48.0972,
    y2: 532.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_5175_27353",
    x1: 1415.8,
    y1: 398.772,
    x2: 1136.18,
    y2: 531.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_5175_27353",
    x1: 116.81,
    y1: 603.76,
    x2: -59.8988,
    y2: 649.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_5175_27353",
    x1: 351.049,
    y1: 603.787,
    x2: 70.3684,
    y2: 737.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_5175_27353",
    x1: 1298.76,
    y1: 603.787,
    x2: 1018.08,
    y2: 737.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_5175_27353",
    x1: 1418.74,
    y1: 603.76,
    x2: 1255.02,
    y2: 642.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_5175_27353",
    x1: 1.29593,
    y1: 851.746,
    x2: -18.1251,
    y2: 852.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_5175_27353",
    x1: 232.596,
    y1: 797.888,
    x2: -0.800374,
    y2: 958.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_5175_27353",
    x1: 469.5,
    y1: 797.888,
    x2: 236.116,
    y2: 958.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_5175_27353",
    x1: 706.43,
    y1: 797.888,
    x2: 473.046,
    y2: 958.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_5175_27353",
    x1: 943.369,
    y1: 797.888,
    x2: 709.973,
    y2: 958.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_5175_27353",
    x1: 1180.27,
    y1: 797.888,
    x2: 946.889,
    y2: 958.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_5175_27353",
    x1: 1415.81,
    y1: 797.888,
    x2: 1182.92,
    y2: 957.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_5175_27353",
    x1: 1421.68,
    y1: 857.271,
    x2: 1417.85,
    y2: 857.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_5175_27353",
    x1: 1373.52,
    y1: -15.757,
    x2: 1351.99,
    y2: -3.90394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_5175_27353",
    x1: 1372.18,
    y1: 90.1457,
    x2: 1353.74,
    y2: 100.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_5175_27353",
    x1: 97.3095,
    y1: 301.669,
    x2: 84.2305,
    y2: 308.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_5175_27353",
    x1: 1009.86,
    y1: 89.1708,
    x2: 988.553,
    y2: 100.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_5175_27353",
    x1: 1101.1,
    y1: 141.303,
    x2: 1078.98,
    y2: 153.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_5175_27353",
    x1: 1188.19,
    y1: 301.57,
    x2: 1174.82,
    y2: 308.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_5175_27353",
    x1: 1099.06,
    y1: 247.754,
    x2: 1081.64,
    y2: 257.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_5175_27353",
    x1: 1190.45,
    y1: 90.0923,
    x2: 1171.86,
    y2: 100.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_5175_27353",
    x1: 1284.74,
    y1: 244.703,
    x2: 1258.36,
    y2: 259.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_5175_27353",
    x1: 1370.65,
    y1: 301.045,
    x2: 1355.74,
    y2: 309.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_5175_27353",
    x1: 1284.62,
    y1: 139.986,
    x2: 1258.53,
    y2: 154.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_5175_27353",
    x1: 11.7782,
    y1: 245.027,
    x2: -13.645,
    y2: 259.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_5175_27353",
    x1: 101.006,
    y1: 403.619,
    x2: 79.4033,
    y2: 415.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_5175_27353",
    x1: 277.897,
    y1: 407.473,
    x2: 267.61,
    y2: 413.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_5175_27353",
    x1: 372.922,
    y1: 456.662,
    x2: 353.083,
    y2: 467.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_5175_27353",
    x1: 463.553,
    y1: 404.445,
    x2: 444.375,
    y2: 415.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_5175_27353",
    x1: 555.834,
    y1: 455.786,
    x2: 533.423,
    y2: 468.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_5175_27353",
    x1: 7.95633,
    y1: 562.587,
    x2: -8.72309,
    y2: 571.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_5175_27353",
    x1: 5.73152,
    y1: 459.514,
    x2: -5.73097,
    y2: 465.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_5175_27353",
    x1: 186.636,
    y1: 460.211,
    x2: 177.231,
    y2: 465.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_5175_27353",
    x1: 280.289,
    y1: 615.33,
    x2: 264.492,
    y2: 624.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_5175_27353",
    x1: 192.426,
    y1: 560.543,
    x2: 169.648,
    y2: 573.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_5175_27353",
    x1: 556.752,
    y1: 559.91,
    x2: 532.21,
    y2: 573.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_5175_27353",
    x1: 1187.72,
    y1: 616.494,
    x2: 1175.45,
    y2: 623.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_5175_27353",
    x1: 1188.6,
    y1: 406.094,
    x2: 1174.27,
    y2: 413.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_5175_27353",
    x1: 1285.47,
    y1: 453.859,
    x2: 1257.41,
    y2: 469.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_5175_27353",
    x1: 1370.78,
    y1: 405.828,
    x2: 1355.57,
    y2: 414.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_5175_27353",
    x1: 98.2015,
    y1: 615.554,
    x2: 83.0651,
    y2: 623.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_5175_27353",
    x1: 102.378,
    y1: 717.096,
    x2: 77.6158,
    y2: 730.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_5175_27353",
    x1: 375.53,
    y1: 559.461,
    x2: 349.665,
    y2: 573.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_5175_27353",
    x1: 459.35,
    y1: 617.481,
    x2: 449.872,
    y2: 622.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_5175_27353",
    x1: 554.367,
    y1: 771.522,
    x2: 535.337,
    y2: 782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_5175_27353",
    x1: 467.85,
    y1: 715.618,
    x2: 438.753,
    y2: 731.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_5175_27353",
    x1: 1189.59,
    y1: 719.93,
    x2: 1173.06,
    y2: 729.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_5175_27353",
    x1: 1373.52,
    y1: 613.38,
    x2: 1351.99,
    y2: 625.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_5175_27353",
    x1: 1373.52,
    y1: 718.227,
    x2: 1351.99,
    y2: 730.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_5175_27353",
    x1: 14.5592,
    y1: 767.161,
    x2: -16.1273,
    y2: 783.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_5175_27353",
    x1: 97.5666,
    y1: 930.639,
    x2: 83.8998,
    y2: 938.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_5175_27353",
    x1: 194.278,
    y1: 873.643,
    x2: 167.238,
    y2: 888.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_5175_27353",
    x1: 190.873,
    y1: 771.469,
    x2: 171.695,
    y2: 782.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_5175_27353",
    x1: 282.897,
    y1: 718.128,
    x2: 261.074,
    y2: 730.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_5175_27353",
    x1: 375.149,
    y1: 769.519,
    x2: 350.24,
    y2: 783.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_5175_27353",
    x1: 463.742,
    y1: 928.578,
    x2: 444.123,
    y2: 939.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_5175_27353",
    x1: 555.097,
    y1: 875.795,
    x2: 534.376,
    y2: 887.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_5175_27353",
    x1: 1098.93,
    y1: 772.169,
    x2: 1081.81,
    y2: 781.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_5175_27353",
    x1: 1281.52,
    y1: 771.545,
    x2: 1262.56,
    y2: 781.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_5175_27353",
    x1: 5.21739,
    y1: 879.348,
    x2: -5.06945,
    y2: 885.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_5175_27353",
    x1: 284.647,
    y1: 926.453,
    x2: 258.783,
    y2: 940.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_5175_27353",
    x1: 369.32,
    y1: 878.921,
    x2: 357.784,
    y2: 885.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_5175_27353",
    x1: 643.66,
    y1: 930.056,
    x2: 628.377,
    y2: 938.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_5175_27353",
    x1: 1099.83,
    y1: 876.32,
    x2: 1080.65,
    y2: 886.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_5175_27353",
    x1: 1187.08,
    y1: 931.606,
    x2: 1176.35,
    y2: 937.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_5175_27353",
    x1: 1281.94,
    y1: 876.069,
    x2: 1262.03,
    y2: 887.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_5175_27353",
    x1: 1374.41,
    y1: 927.23,
    x2: 1350.82,
    y2: 940.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5175_27353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 960,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5175_27353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1452,
    height: 1132,
    fill: "white",
    transform: "translate(-12 -152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginScreenDark);
export default __webpack_public_path__ + "static/media/LoginScreenDark.6f088c6fa6b3a62747bba88e71766329.svg";
export { ForwardRef as ReactComponent };